var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _g, _path194, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 230,
    viewBox: "0 0 189 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10322_11572)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10322_11572)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "#0E907A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2227 200.982C21.3922 203.408 21.7315 234.806 18 252.625V269.542L233.746 278L237.477 155.861C244.601 118.644 176.982 98.4061 151.315 122.365C124.855 147.064 129.265 197.937 69.2227 200.982Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3645 206.641C76.7899 203.254 79.3533 197.68 80.3514 190.574C81.4695 182.624 79.3287 173.188 79.3287 173.188C79.3287 173.188 75.3282 182.904 74.0901 190.574C72.9802 197.455 74.0492 203.966 73.6538 206.737L76.3645 206.641Z",
    fill: "url(#paint0_linear_10322_11572)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6832 206.975C69.3069 203.93 67.1062 198.951 66.2526 192.67C65.309 185.726 67.1116 177.597 67.1116 177.597C67.1116 177.597 70.4959 185.968 71.5731 192.67C72.5521 198.752 71.6658 204.568 72.0176 207.063L69.6832 206.975Z",
    fill: "url(#paint1_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3645 206.641C76.7899 203.254 79.3533 197.68 80.3514 190.574C81.4695 182.624 79.3287 173.188 79.3287 173.188C79.3287 173.188 75.3282 182.904 74.0901 190.574C72.9802 197.455 74.0492 203.966 73.6538 206.737L76.3645 206.641Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6832 206.975C69.3069 203.93 67.1062 198.951 66.2526 192.67C65.309 185.726 67.1116 177.597 67.1116 177.597C67.1116 177.597 70.4959 185.968 71.5731 192.67C72.5521 198.752 71.6658 204.568 72.0176 207.063L69.6832 206.975Z",
    fill: "#246266"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2181 206.736C74.2181 202.904 76.0916 196.53 76.2116 188.29C76.3479 178.915 72.9119 167.569 72.9119 167.569C72.9119 167.569 70.0812 179.248 69.8412 188.29C69.6285 196.271 71.5592 203.71 71.5211 206.844L74.2181 206.734V206.736Z",
    fill: "url(#paint2_linear_10322_11572)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4043 206.745C79.1488 203.16 82.2222 197.234 83.913 189.633C85.8192 181.063 84.6329 170.805 84.6329 170.805C84.6329 170.805 79.6779 181.366 77.7008 189.633C75.9418 196.995 76.3781 203.917 75.7264 206.846L78.4043 206.745Z",
    fill: "url(#paint3_linear_10322_11572)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2835 206.755C66.5881 203.608 63.7465 198.455 62.2194 191.935C60.5259 184.7 61.6712 176.199 61.6712 176.199C61.6712 176.199 66.1327 184.953 67.938 191.935C69.5715 198.249 69.176 204.271 69.7896 206.846L67.2835 206.755Z",
    fill: "url(#paint4_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6712 176.199C61.6712 176.199 62.2848 185.682 64.1556 192.29C65.5545 197.234 68.5106 203.914 69.3342 206.799L67.2835 206.755C66.5881 203.608 63.7465 198.455 62.2194 191.935C60.5259 184.7 61.6712 176.199 61.6712 176.199Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6536 206.737C73.4654 204.123 71.8047 195.994 71.9274 187.79C72.0828 177.451 72.9119 167.572 72.9119 167.572C72.9119 167.572 70.0812 179.251 69.8412 188.293C69.6285 196.274 71.5592 203.713 71.5211 206.847L73.6536 206.737Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6735 206.745C78.3962 203.16 78.118 197.138 79.5633 189.523C81.1941 180.939 84.6329 170.802 84.6329 170.802C84.6329 170.802 79.6779 181.363 77.7008 189.63C75.9418 196.992 76.3781 203.914 75.7264 206.844L77.6708 206.742L77.6735 206.745Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7245 182.745C63.0728 182.877 63.7027 186.863 64.7117 190.574C65.6253 193.928 66.847 197.056 67.7197 196.902C69.555 196.574 64.8044 182.527 63.7245 182.745Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9103 177.952C83.2749 177.759 81.8895 182.802 81.0496 186.554C80.2915 189.946 79.8688 194.634 80.7114 194.909C81.5186 195.176 82.9394 191.33 83.6403 187.479C84.4748 182.89 84.4829 178.125 83.9103 177.952Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5285 174.631C72.5768 174.65 72.3914 192.923 74.4094 192.981C76.4274 193.038 74.7202 174.609 73.5285 174.631Z",
    fill: "#47B3AA"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5843 224.434H76.9127C79.168 220.005 81.0033 214.153 82.3995 206.117H63.0948C64.5947 214.69 66.4163 220.426 68.5816 224.434H68.5843Z",
    fill: "url(#paint5_linear_10322_11572)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3348 207.443C63.253 207.009 63.1739 206.568 63.0948 206.117H82.3995C82.3204 206.566 82.2414 207.009 82.1623 207.443H63.3348Z",
    fill: "#D8CCFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2206 206.117C70.2206 206.117 70.8778 217.254 72.8031 224.434H68.5816C66.4163 220.426 64.5947 214.692 63.0948 206.117H70.2206Z",
    fill: "#60578F"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.246 148.62L130.563 194.705L132.021 196.176L177.704 150.091L176.246 148.62Z",
    fill: "url(#paint6_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.963 194.3L174.126 150.757L176.247 148.617L176.801 149.176L177.706 150.089L175.448 152.367C175.185 152.023 174.916 151.689 174.641 151.355L131.563 194.813C131.894 195.091 132.225 195.362 132.566 195.626L132.025 196.172L130.57 194.7L130.97 194.297L130.963 194.3Z",
    fill: "#9E4435"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.144 218.015H153.867V202.409H150.144V218.015Z",
    fill: "url(#paint7_linear_10322_11572)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.006 198.504C167.472 198.504 180.011 185.855 180.011 170.252C180.011 154.649 167.472 142 152.006 142C136.539 142 124.001 154.649 124.001 170.252C124.001 185.855 136.539 198.504 152.006 198.504Z",
    fill: "url(#paint8_linear_10322_11572)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.94 178.672C156.625 177.587 158.982 177.667 160.745 176.539C161.65 175.96 162.502 175.167 163.325 174.512C163.915 174.042 164.512 173.126 165.203 172.647C166.144 171.995 166.659 172.547 167.692 172.346C168.665 172.157 169.114 171.516 170.271 171.625C170.016 171.883 170.229 171.535 170.153 172.035C171.038 172.26 172.199 173.728 172.287 174.508C172.363 175.176 171.756 175.891 171.848 176.651C171.94 177.399 172.402 177.872 172.425 178.665C172.471 180.309 171.583 181.238 170.589 182.316C169.803 183.173 169.35 184.343 168.403 185.078C167.803 185.544 167.036 185.696 166.403 186.113C164.05 187.664 164.004 191.391 162.361 193.415C161.876 194.013 157.742 197.671 156.693 196.596C156.153 196.04 157.208 195.819 157.352 195.329C157.539 194.694 157.31 194.446 157.267 193.881C157.162 192.555 156.369 191.52 156.228 190.27C156.146 189.519 156.841 188.795 156.271 188.123C155.943 187.74 155.363 188.018 154.946 187.822C153.389 187.092 153.635 185.994 153.904 184.482C154.277 182.382 152.75 180.084 154.943 178.672H154.94Z",
    fill: "url(#paint9_radial_10322_11572)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M178.837 170.871C178.145 171.152 177.519 170.725 176.857 171.059C176.362 171.307 176.041 171.939 175.608 171.949C175.375 172.117 175.077 172.177 174.769 172.15C174.215 170.96 175.634 170.328 176.428 169.74C176.995 169.316 177.336 169.502 177.677 168.698C177.965 168.013 177.896 167.114 177.867 166.37C177.791 164.564 176.139 163.718 174.428 164.032C173.713 164.164 173.402 164.67 172.753 163.992C172.163 163.374 172.192 162.362 171.524 161.674C170.173 160.288 169.439 158.717 167.678 157.825C166.816 157.388 165.915 156.928 165.19 156.353C164 155.41 164.908 155.159 164.44 154.064C164.092 153.248 163.259 153.463 162.532 153.281C161.84 153.109 160.637 152.725 160.244 152.08C159.706 151.194 160.224 150.714 160.548 149.954C160.706 149.583 160.427 149.233 160.83 148.968C161.502 148.529 161.588 149.385 162.073 149.388C162.538 149.392 162.709 148.962 163.092 148.965C163.827 148.972 163.879 149.474 164.325 149.937C165.269 150.916 166.613 151.402 167.99 151.247C169.203 151.111 169.967 150.731 168.737 149.802C168.141 149.352 167.898 149.593 167.76 148.747C167.728 148.552 168.029 148.171 167.891 147.794C168.16 147.665 168.465 147.616 168.793 147.629C175.49 152.695 179.863 160.715 180.011 169.776C179.676 170.285 179.286 170.689 178.84 170.871H178.837Z",
    fill: "url(#paint10_radial_10322_11572)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M129.882 157.143C130.347 157.391 130.603 158.175 131.013 158.301C131.308 158.39 133.045 157.768 133.497 157.642C133.953 157.517 134.769 157.358 134.989 156.941C135.425 156.115 134.497 155.473 135.959 155.47C136.484 155.47 137.31 155.728 137.92 155.8C138.605 155.883 139.182 156.088 139.788 156.343C140.309 156.561 140.709 156.842 141.23 156.809C141.253 156.912 141.289 157.007 141.447 156.994C142.302 157.07 143.299 158.145 143.653 158.833C143.951 159.408 143.922 159.898 144.325 160.47C144.64 160.916 145.056 161.247 145.397 161.657C146.387 162.851 146.646 163.889 146.495 165.424C146.384 166.561 147.023 167.881 146.659 168.866C146.387 169.604 145.653 169.855 145.223 170.444C144.856 170.95 144.82 171.638 144.391 172.114C143.437 173.175 142.099 172.808 140.903 172.927C140.454 172.974 139.978 173.318 139.457 173.139C138.9 172.947 138.674 172.203 137.962 172.071C137.336 171.955 137.116 172.355 136.638 172.415C136.133 172.474 135.667 172.216 135.176 172.279C133.773 172.455 134.471 174.379 133.74 175.424C133.406 175.904 132.878 176.201 132.586 176.787C132.18 177.604 132.265 178.268 132.078 179.115C131.963 179.644 131.232 180.219 131.239 180.626C131.249 181.195 131.862 181.202 132.052 181.655C132.34 182.336 132.065 183.381 131.78 184.013C131.383 184.886 131.239 185.368 131.032 186.311C130.944 186.718 130.698 187.716 130.272 188.067C126.354 183.206 124.007 177.008 124.007 170.255C124.007 166.201 124.856 162.342 126.381 158.856C127.302 157.54 128.488 156.399 129.888 157.146L129.882 157.143Z",
    fill: "url(#paint11_radial_10322_11572)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.711 142.771C150.219 142.298 151.462 142.761 152.97 143.072C153.655 143.214 156.284 143.055 156.375 144.041C156.779 144.484 155.818 144.375 155.569 144.309C155.169 144.203 154.858 144.077 154.451 144.266C154.425 144.778 154.638 145.363 154.868 145.777C155.199 146.372 155.733 146.587 155.556 147.43C155.428 148.029 154.605 148.254 153.999 148.055C153.51 147.897 153.114 147.262 152.72 146.924C152.265 146.534 151.786 146.319 151.206 146.207C150.445 146.058 149.668 145.949 148.918 145.734C147.987 145.469 147.075 144.854 146.108 144.795C145.672 143.912 148.19 142.933 148.711 142.767V142.771Z",
    fill: "url(#paint12_radial_10322_11572)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.456 154.907C143.568 155.691 143.335 156.134 142.463 156.246C141.791 156.332 141.053 155.936 140.476 155.572C140.004 155.274 139.916 155.076 139.726 154.619C139.493 154.057 139.07 154.11 138.713 153.713C138.352 153.31 138.474 152.943 137.788 152.685C137.228 152.473 136.71 152.529 136.176 152.767C135.205 153.204 133.406 154.199 132.389 153.336C131.842 152.873 132.062 152.205 132.422 151.656C133.189 150.489 134.396 149.116 135.785 148.749C136.572 148.541 137.529 148.597 138.264 148.945C138.87 149.232 139.067 149.92 139.667 150.238C140.349 150.598 141.037 150.373 140.572 151.359C140.44 151.636 140.237 151.765 140.257 152.159C140.27 152.46 140.286 152.711 140.578 152.863C141.371 153.273 142.46 152.576 143.26 153.105V153.111C143.591 153.28 143.558 153.601 143.525 153.915C143.483 154.308 143.397 154.484 143.456 154.907Z",
    fill: "url(#paint13_radial_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M152.006 142C158.008 142 163.568 143.905 168.124 147.146C164.708 145.337 160.821 144.312 156.697 144.312C143.109 144.312 132.094 155.423 132.094 169.131C132.094 182.838 143.109 193.95 156.697 193.95C164.944 193.95 172.242 189.856 176.706 183.576C171.986 192.458 162.696 198.504 152.006 198.504C136.54 198.504 124.001 185.854 124.001 170.252C124.001 154.649 136.54 142 152.006 142Z",
    fill: "#26426A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M151.576 202.405V202.475C151.721 202.475 151.861 202.475 152.006 202.475C152.632 202.475 153.251 202.455 153.868 202.418V205.891C153.251 205.924 152.629 205.944 152.006 205.944C151.861 205.944 151.721 205.944 151.576 205.944V218.014H150.144V205.897V202.425V202.409H151.576V202.405Z",
    fill: "#9E4435"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M128.656 223.359H175.356V220.468C159.598 215.845 144.033 215.845 128.656 220.468V223.359Z",
    fill: "url(#paint14_linear_10322_11572)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M152.006 204.575C170.766 204.575 186.029 189.178 186.029 170.255C186.029 161.075 182.483 152.447 176.041 145.962L173.615 148.419C179.404 154.249 182.594 162.004 182.594 170.255C182.594 187.266 168.875 201.11 152.009 201.11C143.83 201.11 136.143 197.892 130.364 192.052L127.928 194.502C134.356 201 142.909 204.579 152.006 204.579V204.575Z",
    fill: "url(#paint15_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M151.825 217.003C148.76 217.936 147.062 220.472 147.062 220.472H175.356V223.362H128.656V220.472C136.33 218.164 144.056 217.006 151.825 217.003Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M182.735 169.097C182.735 170.599 182.627 172.077 182.42 173.522C182.532 172.447 182.591 171.356 182.591 170.252C182.591 161.997 179.404 154.242 173.612 148.415L174.251 147.771C179.725 153.538 182.735 161.081 182.735 169.097Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M128.577 193.844C134.946 200.024 143.289 203.417 152.15 203.417C169.272 203.417 183.482 190.59 185.833 173.962C183.994 191.148 169.524 204.572 152.009 204.572C142.909 204.572 134.36 200.993 127.931 194.495L128.58 193.84L128.577 193.844Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.939 149.024C146.203 157.199 167.672 168.43 172.94 164.23C181.112 157.718 164.433 141.894 155.939 149.024Z",
    fill: "#FFF7E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.95 168.549C165.312 168.023 168.003 178.636 171.668 178.781C177.355 179.006 178.935 168.963 172.95 168.549Z",
    fill: "#FFF7E6"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9999 226.967L115.976 226.782L84.3977 195.107L52.9999 226.964V226.967ZM101.365 220.915L67.5744 221.015L84.4207 203.921L101.365 220.915Z",
    fill: "url(#paint16_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5983 200.058L81.736 199.919L80.6902 198.871L80.5526 199.007L81.5983 200.058Z",
    fill: "#463332"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7492 200.922L80.8836 200.783L79.8379 199.734L79.7035 199.87L80.7492 200.922Z",
    fill: "#463332"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8088 202.885L78.9432 202.75L77.8975 201.698L77.7631 201.837L78.8088 202.885Z",
    fill: "#463332"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9561 203.749L78.0937 203.613L77.048 202.562L76.9103 202.7L77.9561 203.749Z",
    fill: "#463332"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0155 205.713L76.1531 205.578L75.1074 204.529L74.973 204.665L76.0155 205.713Z",
    fill: "#463332"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1665 206.576L75.3009 206.441L74.2552 205.393L74.1208 205.528L75.1665 206.576Z",
    fill: "#463332"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.226 208.544L73.3604 208.405L72.3179 207.356L72.1802 207.492L73.226 208.544Z",
    fill: "#463332"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3735 209.407L72.5112 209.268L71.4654 208.22L71.3278 208.355L72.3735 209.407Z",
    fill: "#463332"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M70.436 211.372L70.5704 211.236L69.5247 210.185L69.3903 210.323L70.436 211.372Z",
    fill: "#463332"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5838 212.235L69.7182 212.096L68.6725 211.048L68.5381 211.183L69.5838 212.235Z",
    fill: "#463332"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6433 214.199L67.7809 214.063L66.7352 213.012L66.5975 213.151L67.6433 214.199Z",
    fill: "#463332"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7909 215.062L66.9286 214.927L65.8829 213.875L65.7452 214.014L66.7909 215.062Z",
    fill: "#463332"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8305 217.053L64.9649 216.915L63.9191 215.866L63.7847 216.002L64.8305 217.053Z",
    fill: "#463332"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9783 217.916L64.1127 217.777L63.067 216.729L62.9326 216.864L63.9783 217.916Z",
    fill: "#463332"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0275 219.891L62.1619 219.755L61.1162 218.707L60.9818 218.843L62.0275 219.891Z",
    fill: "#463332"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1758 220.754L61.3102 220.618L60.2645 219.566L60.1301 219.705L61.1758 220.754Z",
    fill: "#463332"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1794 222.777L59.3138 222.641L58.2681 221.59L58.1337 221.729L59.1794 222.777Z",
    fill: "#463332"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M58.327 223.64L58.4614 223.505L57.4189 222.453L57.2812 222.592L58.327 223.64Z",
    fill: "#463332"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4305 199.976L83.6141 199.791L81.6898 197.859L81.5062 198.045L83.4305 199.976Z",
    fill: "#463332"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6278 202.817L80.8113 202.632L78.8871 200.697L78.7035 200.886L80.6278 202.817Z",
    fill: "#463332"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8251 205.657L78.0087 205.472L76.0844 203.537L75.9008 203.726L77.8251 205.657Z",
    fill: "#463332"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0224 208.498L75.206 208.313L73.2817 206.378L73.0981 206.566L75.0224 208.498Z",
    fill: "#463332"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2194 211.339L72.403 211.153L70.4787 209.219L70.2952 209.404L72.2194 211.339Z",
    fill: "#463332"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4166 214.179L69.6001 213.994L67.6759 212.06L67.4923 212.245L69.4166 214.179Z",
    fill: "#463332"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6138 217.02L66.7973 216.832L64.8698 214.9L64.6862 215.086L66.6138 217.02Z",
    fill: "#463332"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8111 219.861L63.9947 219.673L62.0671 217.741L61.8835 217.926L63.8111 219.861Z",
    fill: "#463332"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0083 222.699L61.1919 222.513L59.2643 220.582L59.0807 220.767L61.0083 222.699Z",
    fill: "#463332"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2022 225.539L58.3858 225.354L56.4615 223.423L56.2812 223.608L58.2022 225.539Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8473 226.888C80.8473 226.626 80.8473 225.803 80.8408 224.381H82.4372L82.4274 220.971L101.365 220.915L86.9676 206.473C86.925 206.311 86.8692 206.156 86.8659 205.981L86.843 197.865C86.843 197.776 86.8823 197.703 86.8922 197.617L115.972 226.785L80.844 226.888H80.8473Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M101.719 220.572L101.024 220.575L84.4273 203.928L84.7748 203.577L101.719 220.572Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3945 195.111L84.6437 195.359L53.8293 226.624L115.632 226.442L115.973 226.786L52.9999 226.968L84.3945 195.111Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5421 221.499L86.2928 221.443L86.2915 220.99L67.5407 221.046L67.5421 221.499Z",
    fill: "#FFF7E6"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M182.151 225.365L182.966 225.151L182.4 222.956L181.585 223.17L182.151 225.365Z",
    fill: "url(#paint17_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M182.148 225.37L182.563 225.261L181.997 223.065L181.582 223.174L182.148 225.37Z",
    fill: "#463332"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M179.86 226.709L185.531 226.693C185.983 226.693 186.35 226.319 186.35 225.863C186.35 225.407 185.98 225.036 185.528 225.036L179.856 225.053C179.404 225.053 179.037 225.426 179.037 225.883C179.037 226.339 179.407 226.709 179.86 226.709Z",
    fill: "url(#paint18_linear_10322_11572)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M182.04 223.244C182.817 223.039 183.282 222.239 183.079 221.455L182.768 220.245C182.564 219.461 181.771 218.991 180.994 219.197C180.217 219.402 179.752 220.202 179.955 220.986L180.266 222.196C180.47 222.98 181.263 223.449 182.04 223.244Z",
    fill: "url(#paint19_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M180.998 219.196C181.181 219.146 181.365 219.143 181.545 219.166C181.748 219.289 181.971 219.378 182.204 219.444C182.469 219.636 182.682 219.904 182.771 220.248L183.056 221.349C182.719 221.716 182.302 222.017 181.788 222.152C181.548 222.215 181.309 222.232 181.07 222.228C181.394 222.761 182.014 223.055 182.643 222.896C182.473 223.052 182.279 223.184 182.04 223.247C181.263 223.452 180.47 222.979 180.266 222.199L179.955 220.988C179.752 220.205 180.217 219.404 180.994 219.199L180.998 219.196Z",
    fill: "#463332"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M181.627 221.647C183.073 221.266 183.938 219.778 183.561 218.323L168.855 161.271L163.623 162.643L178.329 219.695C178.706 221.154 180.181 222.027 181.624 221.647H181.627Z",
    fill: "url(#paint20_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M163.627 162.643L168.859 161.271L169.416 163.433C168.836 164.439 167.98 165.249 166.957 165.778L180.165 217.013C180.542 218.472 182.017 219.345 183.459 218.965C183.525 218.948 183.584 218.915 183.649 218.895C183.702 220.152 182.886 221.319 181.63 221.647C180.184 222.027 178.709 221.15 178.336 219.695L164.607 166.439L163.63 162.643H163.627Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M179.853 225.056L182.118 225.05C181.666 225.05 181.299 225.423 181.299 225.88C181.299 226.336 181.669 226.707 182.122 226.703L179.857 226.71C179.404 226.71 179.034 226.343 179.034 225.886C179.034 225.43 179.398 225.056 179.85 225.056H179.853Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M179.857 226.148L185.528 226.131C185.882 226.131 186.177 225.9 186.291 225.582C186.324 225.671 186.347 225.764 186.347 225.863C186.347 226.319 185.983 226.693 185.528 226.693L179.857 226.71C179.404 226.71 179.034 226.343 179.034 225.886C179.034 225.787 179.057 225.694 179.089 225.605C179.204 225.923 179.499 226.151 179.857 226.151V226.148Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M185.793 225.41C185.895 225.095 183.971 225.171 183.902 225.337C183.797 225.595 185.705 225.684 185.793 225.41Z",
    fill: "#FFF7E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M183.659 225.41C183.695 225.181 183.026 225.238 183.003 225.357C182.967 225.542 183.63 225.608 183.659 225.41Z",
    fill: "#FFF7E6"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M144.548 224.341C145.981 224.755 147.472 223.915 147.882 222.469L148.515 220.237C148.924 218.792 148.092 217.287 146.659 216.874C145.227 216.461 143.735 217.301 143.325 218.746L142.693 220.978C142.283 222.423 143.116 223.928 144.548 224.341Z",
    fill: "url(#paint21_linear_10322_11572)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M144.001 226.272C145.053 226.576 146.151 225.957 146.453 224.896L146.918 223.252C147.22 222.191 146.607 221.083 145.554 220.779C144.502 220.474 143.404 221.093 143.102 222.154L142.637 223.798C142.335 224.86 142.948 225.967 144.001 226.272Z",
    fill: "url(#paint22_linear_10322_11572)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M145.118 222.32C146.554 222.734 148.049 221.894 148.459 220.445L164.787 162.712L159.591 161.217L143.263 218.951C142.853 220.399 143.686 221.907 145.121 222.32H145.118Z",
    fill: "url(#paint23_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M143.26 218.951L158.988 163.34L159.588 161.217L164.784 162.712L163.735 166.422C162.683 166.336 161.712 165.976 160.886 165.413L146.099 217.704C145.689 219.152 146.521 220.66 147.957 221.074C148.023 221.093 148.092 221.097 148.157 221.11C147.541 222.129 146.312 222.661 145.118 222.317C143.683 221.904 142.853 220.396 143.263 218.947L143.26 218.951Z",
    fill: "#9E4435"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M162.44 156.392L165.99 156.382L165.967 148.423C165.967 147.434 165.167 146.633 164.187 146.637C163.207 146.637 162.414 147.444 162.417 148.432L162.44 156.392Z",
    fill: "url(#paint24_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M164.187 146.637C164.292 146.637 164.384 146.68 164.485 146.696C163.928 147 163.538 147.576 163.541 148.257L163.551 151.604C163.767 151.574 163.981 151.544 164.203 151.541C164.826 151.541 165.413 151.66 165.98 151.835L165.993 156.211V156.382L162.443 156.392L162.43 151.845L162.42 148.432C162.42 147.444 163.21 146.64 164.19 146.637H164.187Z",
    fill: "#463332"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M168.475 163.118C170.826 160.746 170.826 156.902 168.475 154.531C166.125 152.16 162.314 152.16 159.963 154.531C157.613 156.902 157.613 160.746 159.963 163.118C162.314 165.489 166.125 165.489 168.475 163.118Z",
    fill: "url(#paint25_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M160.981 158.654C160.988 160.559 162.535 162.097 164.443 162.094C166.351 162.087 167.891 160.539 167.885 158.635C167.878 156.73 166.331 155.192 164.423 155.195C162.515 155.202 160.975 156.75 160.981 158.654Z",
    fill: "#9E4435"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M166.509 161.135C167.774 159.859 167.774 157.79 166.509 156.514C165.245 155.238 163.194 155.238 161.929 156.514C160.664 157.79 160.664 159.859 161.929 161.135C163.194 162.411 165.245 162.411 166.509 161.135Z",
    fill: "url(#paint26_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M163.214 152.854C160.837 153.529 159.086 155.712 159.093 158.324C159.103 161.466 161.633 164.002 164.748 163.996C167.337 163.989 169.491 162.21 170.147 159.809C169.681 162.686 167.226 164.889 164.243 164.899C160.919 164.909 158.214 162.197 158.205 158.843C158.195 155.831 160.368 153.344 163.217 152.858L163.214 152.854Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M164.108 156.531C162.896 157.556 165.58 158.949 166.236 158.423C167.252 157.606 165.167 155.638 164.108 156.531Z",
    fill: "#FFF7E6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M166.236 158.962C165.282 158.899 165.623 160.222 166.079 160.239C166.79 160.265 166.983 159.012 166.236 158.962Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M164.407 147.073C163.571 147.543 164.977 148.634 165.426 148.396C166.124 148.026 165.138 146.663 164.407 147.073Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M164.21 155.556C164.249 155.556 164.286 155.566 164.325 155.566C162.745 155.632 161.486 156.938 161.489 158.549C161.493 160.199 162.823 161.528 164.456 161.525C166.092 161.522 167.41 160.179 167.406 158.532C167.406 158.367 167.383 158.205 167.357 158.046C167.416 158.294 167.459 158.549 167.459 158.813C167.465 160.619 166.016 162.084 164.23 162.09C162.44 162.097 160.988 160.635 160.981 158.833C160.975 157.031 162.424 155.562 164.21 155.556Z",
    fill: "#463332"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M126.679 197.26L156.434 197.174L169.917 226.748L140.732 226.834L126.751 198.268C126.59 197.944 126.58 197.587 126.676 197.263L126.679 197.26Z",
    fill: "url(#paint27_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M126.679 197.26L156.434 197.174L169.917 226.748L140.732 226.834L126.751 198.268C126.59 197.944 126.58 197.587 126.676 197.263L126.679 197.26Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M127.672 200.14L126.754 198.265C126.594 197.941 126.584 197.584 126.679 197.26L156.435 197.174L157.746 200.051L127.672 200.14Z",
    fill: "#60578F"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M156.434 197.174L126.679 197.26C126.784 196.907 127.02 196.596 127.374 196.42L132.462 193.887C132.54 193.848 132.875 193.755 132.957 193.755C132.986 193.755 133.012 193.755 133.042 193.755L162.381 193.669L162.397 199.175L157.356 199.188L156.438 197.174H156.434Z",
    fill: "url(#paint28_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M156.434 197.174L126.679 197.26C126.784 196.907 127.02 196.596 127.374 196.42L132.462 193.887C132.766 193.735 132.953 193.755 133.042 193.755L162.381 193.669L156.434 197.174Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M150.367 196.354L155.454 193.82C155.759 193.668 155.946 193.688 156.034 193.688L158.824 193.682C158.739 193.682 158.549 193.662 158.244 193.814L153.156 196.347C152.802 196.522 152.566 196.836 152.461 197.187L149.672 197.194C149.776 196.84 150.012 196.529 150.367 196.354Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M129.823 196.413L134.91 193.88C135.215 193.728 135.402 193.748 135.491 193.748L138.28 193.741C138.195 193.741 138.005 193.721 137.7 193.873L132.612 196.407C132.258 196.582 132.022 196.896 131.917 197.247L129.128 197.253C129.233 196.899 129.469 196.588 129.823 196.413Z",
    fill: "#60578F"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M170.881 225.204L175.654 222.827L176.074 223.68C176.988 223.223 177.457 222.992 177.457 222.992L163.476 194.426C163.141 193.745 162.322 193.464 161.647 193.801L156.559 196.334C155.884 196.671 155.605 197.498 155.939 198.179L169.921 226.745C169.921 226.745 170.393 226.511 171.301 226.058L170.881 225.204Z",
    fill: "url(#paint29_linear_10322_11572)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M162.913 196.773L175.665 222.825L170.892 225.203L158.14 199.151C157.928 198.718 158.104 198.195 158.533 197.982L161.754 196.377C162.183 196.163 162.701 196.34 162.913 196.773Z",
    fill: "#CEB6AA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M162.89 196.736L158.117 199.114L170.882 225.193L175.655 222.815L162.89 196.736Z",
    fill: "#CEB6AA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M161.689 196.287L158.49 197.881C158.054 198.096 157.877 198.629 158.093 199.065L170.885 225.201L175.657 222.823L162.866 196.688C162.653 196.248 162.125 196.069 161.693 196.287H161.689Z",
    fill: "#FFE6D6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M162.24 198.553C162.024 198.113 161.499 197.935 161.063 198.15L158.313 199.519L158.09 199.062C157.877 198.622 158.054 198.093 158.486 197.878L161.686 196.284C162.122 196.069 162.646 196.248 162.859 196.685L175.651 222.82L174.415 223.435L162.237 198.55L162.24 198.553Z",
    fill: "#CEB6AA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M160.102 198.546C160.102 198.546 160.765 199.971 161.761 202.108C162.781 204.234 164.141 207.065 165.501 209.899C166.905 212.71 168.308 215.524 169.36 217.631C170.438 219.727 171.156 221.123 171.156 221.123C171.156 221.123 170.494 219.698 169.498 217.561C168.478 215.435 167.118 212.604 165.757 209.77C164.354 206.959 162.951 204.148 161.899 202.038C160.82 199.941 160.102 198.546 160.102 198.546Z",
    fill: "#CEB6AA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M170.176 216.255C170.176 216.255 170.343 216.688 170.612 217.326C170.881 217.965 171.274 218.801 171.671 219.635C172.087 220.461 172.503 221.285 172.844 221.89C173.182 222.495 173.425 222.892 173.425 222.892C173.425 222.892 173.261 222.459 172.989 221.821C172.72 221.182 172.326 220.346 171.927 219.512C171.51 218.686 171.094 217.862 170.753 217.26C170.415 216.655 170.173 216.258 170.173 216.258L170.176 216.255Z",
    fill: "#CEB6AA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M160.345 201.559C160.345 201.559 160.843 202.647 161.588 204.28C162.342 205.911 163.381 208.063 164.423 210.22C165.485 212.366 166.547 214.509 167.37 216.103C168.203 217.693 168.757 218.755 168.757 218.755C168.757 218.755 168.259 217.667 167.514 216.033C166.76 214.403 165.721 212.25 164.679 210.094C163.617 207.948 162.555 205.805 161.729 204.211C160.896 202.62 160.342 201.559 160.342 201.559H160.345Z",
    fill: "#CEB6AA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M152.062 205.541L152.039 197.925H153.379C153.376 196.463 153.373 195.716 153.373 195.716L91.7671 195.894C90.6985 195.894 89.833 196.774 89.8363 197.855L89.8593 205.971C89.8593 207.049 90.7312 207.922 91.8032 207.919L153.409 207.74C153.409 207.74 153.409 206.989 153.402 205.538H152.062V205.541Z",
    fill: "url(#paint30_linear_10322_11572)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M152.061 205.54L94.396 205.709C93.7174 205.709 93.1667 205.16 93.1667 204.476L93.1536 199.337C93.1536 198.652 93.6977 198.096 94.3763 198.096L152.042 197.928L152.065 205.544L152.061 205.54Z",
    fill: "#CEB6AA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M152.045 197.917L121.205 198.01L121.227 205.626L152.068 205.533L152.045 197.917Z",
    fill: "#CEB6AA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M152.045 197.917L121.205 198.01L121.227 205.626L152.068 205.533L152.045 197.917Z",
    fill: "#FFE6D6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M122.752 202.721C122.752 202.721 124.273 202.764 126.554 202.823C128.836 202.873 131.878 202.883 134.92 202.889C137.962 202.866 141.004 202.84 143.286 202.777C145.567 202.701 147.088 202.651 147.088 202.651C147.088 202.651 145.567 202.608 143.286 202.549C141.004 202.499 137.962 202.489 134.92 202.482C131.878 202.506 128.836 202.535 126.554 202.595C124.273 202.671 122.752 202.721 122.752 202.721Z",
    fill: "#CEB6AA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M140.329 200.865C140.329 200.865 140.978 200.921 141.955 200.974C142.932 201.027 144.23 201.043 145.531 201.053C146.833 201.037 148.131 201.014 149.108 200.954C150.085 200.901 150.734 200.835 150.734 200.835C150.734 200.835 150.085 200.772 149.108 200.726C148.131 200.673 146.833 200.656 145.531 200.646C144.23 200.663 142.932 200.689 141.955 200.746C140.981 200.805 140.329 200.865 140.329 200.865Z",
    fill: "#CEB6AA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M126.705 204.287C126.705 204.287 127.698 204.343 129.19 204.393C130.681 204.446 132.668 204.459 134.655 204.466C136.641 204.446 138.628 204.419 140.116 204.36C141.604 204.307 142.597 204.238 142.597 204.238C142.597 204.238 141.604 204.175 140.113 204.128C138.621 204.076 136.635 204.062 134.648 204.056C132.661 204.076 130.675 204.102 129.187 204.161C127.698 204.221 126.705 204.284 126.705 204.284V204.287Z",
    fill: "#CEB6AA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M152.042 197.921L121.201 198.014L121.207 199.743L152.047 199.651L152.042 197.921Z",
    fill: "#CEB6AA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7671 195.898L119.903 195.815L119.939 207.84L91.8032 207.922C90.7345 207.922 89.8625 207.053 89.8593 205.975L89.8363 197.859C89.8363 196.781 90.6984 195.901 91.7671 195.898Z",
    fill: "url(#paint31_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7671 195.898L119.657 195.815C118.589 195.815 117.723 196.695 117.727 197.776L117.75 205.892C117.75 206.97 118.622 207.843 119.693 207.84L91.8032 207.922C90.7345 207.922 89.8625 207.053 89.8593 205.975L89.8363 197.859C89.8363 196.781 90.6984 195.901 91.7671 195.898Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M111.154 205.911L111.131 197.796C111.131 196.718 111.993 195.838 113.062 195.835L114.966 195.828C113.897 195.828 113.032 196.708 113.035 197.789L113.058 205.905C113.058 206.983 113.93 207.856 115.002 207.852L113.098 207.859C112.029 207.859 111.157 206.989 111.154 205.911Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9897 205.964L92.9668 197.849C92.9668 196.77 93.8289 195.891 94.8976 195.887L96.8022 195.881C95.7335 195.881 94.8681 196.761 94.8714 197.842L94.8943 205.957C94.8943 207.035 95.7663 207.908 96.8383 207.905L94.9337 207.912C93.865 207.912 92.993 207.042 92.9897 205.964Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M117.75 205.627V205.892C117.753 206.97 118.622 207.843 119.694 207.839L91.8032 207.922C90.7346 207.922 89.8626 207.052 89.8593 205.974V205.71L117.75 205.627Z",
    fill: "#398191"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M149.554 194.353L149.54 189.684H150.363C150.363 188.787 150.36 188.331 150.36 188.331L93.9927 188.496C93.3371 188.496 92.806 189.035 92.8093 189.697L92.8224 194.674C92.8224 195.335 93.3567 195.871 94.0124 195.868L150.38 195.702C150.38 195.702 150.38 195.243 150.376 194.35H149.554V194.353Z",
    fill: "url(#paint32_linear_10322_11572)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5919 189.836L149.546 189.674L149.56 194.344L95.6056 194.505C95.1893 194.506 94.8539 194.167 94.8527 193.75L94.8434 190.599C94.8422 190.179 95.1788 189.84 95.5919 189.839L95.5919 189.836Z",
    fill: "#CEB6AA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M149.543 189.677L123.852 189.754L123.866 194.423L149.557 194.346L149.543 189.677Z",
    fill: "#CEB6AA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M149.543 189.677L123.852 189.754L123.866 194.423L149.557 194.346L149.543 189.677Z",
    fill: "#FFE6D6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M124.801 192.643C124.801 192.643 126.158 192.666 128.19 192.699C130.226 192.709 132.937 192.722 135.651 192.735C138.366 192.706 141.077 192.679 143.112 192.656C145.148 192.61 146.502 192.58 146.502 192.58C146.502 192.58 145.145 192.557 143.112 192.524C141.077 192.514 138.366 192.501 135.651 192.487C132.937 192.517 130.226 192.544 128.19 192.567C126.155 192.613 124.801 192.643 124.801 192.643Z",
    fill: "#CEB6AA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M142.361 191.486C142.361 191.486 142.761 191.525 143.358 191.548C143.955 191.562 144.754 191.582 145.551 191.601C147.147 191.608 148.741 191.466 148.741 191.466C148.741 191.466 147.144 191.334 145.551 191.35C144.754 191.373 143.958 191.396 143.358 191.413C142.761 191.443 142.361 191.482 142.361 191.482V191.486Z",
    fill: "#CEB6AA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M127.226 193.605C127.226 193.605 128.259 193.629 129.81 193.665C131.36 193.675 133.425 193.691 135.491 193.705C139.621 193.705 143.755 193.556 143.755 193.556C143.755 193.556 139.624 193.434 135.491 193.453C133.425 193.48 131.36 193.506 129.81 193.526C128.259 193.572 127.226 193.602 127.226 193.602V193.605Z",
    fill: "#CEB6AA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M149.543 189.677L123.852 189.754L123.855 190.812L149.546 190.735L149.543 189.677Z",
    fill: "#CEB6AA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9894 188.496L123.053 188.41L123.073 195.781L94.0091 195.867C93.3535 195.867 92.8191 195.335 92.8191 194.674L92.806 189.697C92.806 189.035 93.3338 188.496 93.9894 188.496Z",
    fill: "url(#paint33_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9894 188.497L122.902 188.414C122.247 188.414 121.716 188.953 121.719 189.615L121.732 194.592C121.732 195.253 122.267 195.789 122.922 195.785L94.0091 195.868C93.3535 195.868 92.8191 195.336 92.8191 194.674L92.806 189.697C92.806 189.036 93.3338 188.497 93.9894 188.497Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M117.69 194.601L117.677 189.624C117.677 188.963 118.205 188.424 118.861 188.424H120.028C119.372 188.424 118.841 188.96 118.844 189.621L118.857 194.598C118.857 195.259 119.392 195.795 120.047 195.792H118.88C118.225 195.798 117.69 195.263 117.69 194.601Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M114.527 194.611L114.514 189.634C114.514 188.973 115.042 188.434 115.697 188.434H116.864C116.209 188.434 115.678 188.969 115.681 189.631L115.694 194.608C115.694 195.269 116.228 195.805 116.884 195.802H115.717C115.061 195.808 114.527 195.272 114.527 194.611Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M98.251 194.657L98.2379 189.68C98.2379 189.019 98.7657 188.479 99.4213 188.479H100.588C99.9327 188.479 99.4016 189.015 99.4049 189.677L99.418 194.654C99.418 195.315 99.9524 195.851 100.608 195.848H99.441C98.7854 195.854 98.251 195.318 98.251 194.657Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0877 194.667L95.0746 189.69C95.0746 189.028 95.6024 188.489 96.258 188.489H97.425C96.7694 188.489 96.2383 189.025 96.2416 189.686L96.2547 194.663C96.2547 195.325 96.789 195.861 97.4447 195.857H96.2777C95.622 195.864 95.0877 195.328 95.0877 194.667Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M121.735 194.426V194.588C121.735 195.25 122.27 195.785 122.925 195.782L94.0123 195.865C93.3567 195.865 92.8224 195.332 92.8224 194.671V194.509L121.735 194.423V194.426Z",
    fill: "#9E4435"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4302 224.368L85.3908 210.389H83.7944C83.7878 208.656 83.7878 207.767 83.7878 207.767L157.185 207.552C158.46 207.548 159.496 208.587 159.499 209.873L159.542 224.447C159.545 225.734 158.516 226.779 157.241 226.782L83.8436 226.997C83.8436 226.997 83.8436 226.101 83.837 224.371H85.4335L85.4302 224.368Z",
    fill: "url(#paint34_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M156.083 224.163L87.3802 224.368L87.3391 210.39L156.042 210.184C156.848 210.182 157.506 210.841 157.508 211.654L157.541 222.683C157.543 223.497 156.889 224.16 156.083 224.163Z",
    fill: "#A0335D"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4303 224.368L154.133 224.166C154.94 224.166 155.592 223.502 155.592 222.688L155.559 211.659C155.559 210.846 154.9 210.188 154.094 210.188L85.3909 210.389L85.4303 224.368Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7913 210.396C83.7848 208.657 83.7848 207.77 83.7848 207.77L121.237 207.661L121.293 226.891L83.8405 227.001C83.8405 227.001 83.8405 226.104 83.834 224.375H85.4304L85.3911 210.393H83.7946L83.7913 210.396Z",
    fill: "#A0335D"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M122.136 210.277L85.3951 210.387L85.4363 224.365L122.177 224.255L122.136 210.277Z",
    fill: "#CEB6AA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M122.136 210.277L85.3951 210.387L85.4363 224.365L122.177 224.255L122.136 210.277Z",
    fill: "#CEB6AA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M120.89 210.286L154.094 210.19C154.9 210.19 155.556 210.845 155.559 211.662L155.566 213.752C155.566 212.939 154.907 212.28 154.101 212.28L120.896 212.376L120.89 210.286Z",
    fill: "#CEB6AA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M153.088 214.132C153.088 214.132 152.117 214.043 150.665 213.98C149.938 213.957 149.092 213.907 148.184 213.901C147.276 213.891 146.305 213.881 145.338 213.871C144.368 213.888 143.401 213.901 142.493 213.917C141.585 213.931 140.736 213.987 140.011 214.013C138.559 214.086 137.589 214.182 137.589 214.182C137.589 214.182 138.559 214.271 140.011 214.337C140.739 214.357 141.585 214.41 142.493 214.417C143.401 214.427 144.371 214.437 145.338 214.447C146.309 214.43 147.276 214.413 148.184 214.4C149.092 214.387 149.941 214.331 150.665 214.304C152.117 214.232 153.088 214.136 153.088 214.136V214.132Z",
    fill: "#CEB6AA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M148.495 221.689C148.495 221.689 147.075 221.609 144.945 221.54C143.879 221.517 142.637 221.49 141.306 221.464C139.975 221.454 138.556 221.447 137.136 221.438C135.717 221.454 134.297 221.471 132.966 221.487C131.635 221.5 130.393 221.56 129.328 221.586C127.197 221.669 125.777 221.758 125.777 221.758C125.777 221.758 127.197 221.838 129.328 221.91C130.393 221.93 131.635 221.98 132.966 221.986C134.297 221.993 135.717 222.003 137.136 222.013C138.556 221.996 139.975 221.98 141.306 221.963C142.637 221.927 143.879 221.894 144.945 221.864C147.075 221.781 148.495 221.692 148.495 221.692V221.689Z",
    fill: "#CEB6AA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M150.793 216.742C150.793 216.742 149.373 216.662 147.242 216.593C146.177 216.57 144.935 216.543 143.604 216.517C142.273 216.507 140.853 216.5 139.434 216.49C138.014 216.507 136.595 216.523 135.264 216.54C133.933 216.553 132.691 216.613 131.625 216.639C129.495 216.722 128.075 216.811 128.075 216.811C128.075 216.811 129.495 216.89 131.625 216.963C132.691 216.983 133.933 217.033 135.264 217.039C136.595 217.046 138.014 217.056 139.434 217.066C140.853 217.049 142.273 217.033 143.604 217.016C144.935 216.98 146.177 216.947 147.242 216.917C149.373 216.834 150.793 216.745 150.793 216.745V216.742Z",
    fill: "#CEB6AA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M120.326 219.844C120.326 219.844 118.513 219.744 115.796 219.675C114.435 219.648 112.852 219.622 111.154 219.589C109.456 219.579 107.643 219.572 105.83 219.562C104.017 219.582 102.208 219.602 100.506 219.622C98.8083 219.639 97.2217 219.705 95.8646 219.734C93.147 219.82 91.3342 219.93 91.3342 219.93C91.3342 219.93 93.147 220.029 95.8646 220.098C97.225 220.121 98.8083 220.178 100.506 220.184C102.204 220.194 104.017 220.201 105.83 220.211C107.643 220.191 109.452 220.171 111.154 220.151C112.852 220.111 114.438 220.072 115.796 220.039C118.513 219.953 120.326 219.844 120.326 219.844Z",
    fill: "#B29B93"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3623 213.812C99.3623 213.812 98.5887 213.746 97.425 213.699C96.2612 213.647 94.714 213.63 93.1634 213.62C91.6129 213.64 90.0656 213.663 88.9018 213.726C87.7414 213.779 86.9645 213.852 86.9645 213.852C86.9645 213.852 87.7381 213.918 88.9018 213.964C90.0656 214.017 91.6129 214.033 93.1634 214.043C94.714 214.024 96.2612 214 97.425 213.938C98.5854 213.885 99.3623 213.812 99.3623 213.812Z",
    fill: "#B29B93"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M114.54 222.288C114.54 222.288 113.357 222.208 111.58 222.149C109.803 222.082 107.436 222.063 105.073 222.053C102.706 222.076 100.339 222.109 98.5658 222.185C96.7924 222.254 95.6089 222.34 95.6089 222.34C95.6089 222.34 96.7923 222.42 98.5691 222.479C100.346 222.545 102.713 222.562 105.076 222.575C107.443 222.549 109.81 222.519 111.583 222.443C113.357 222.374 114.54 222.288 114.54 222.288Z",
    fill: "#B29B93"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M113.98 216.252C113.98 216.252 112.796 216.173 111.02 216.113C109.243 216.047 106.876 216.027 104.513 216.018C102.146 216.041 99.779 216.074 98.0055 216.15C96.232 216.219 95.0486 216.305 95.0486 216.305C95.0486 216.305 96.232 216.385 98.0088 216.444C99.7855 216.51 102.152 216.527 104.516 216.54C106.883 216.514 109.249 216.484 111.023 216.408C112.796 216.338 113.98 216.252 113.98 216.252Z",
    fill: "#B29B93"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M122.136 210.277L85.3951 210.387L85.4012 212.447L122.142 212.337L122.136 210.277Z",
    fill: "#B29B93"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M146.849 212.44C145.908 214.642 145.607 221.008 145.564 224.249H161.689C161.716 221.104 161.476 214.533 160.48 212.165C159.08 208.832 155.54 206.735 155.54 205.931C155.54 205.128 158.375 203.216 159.929 200.336C161.214 197.958 161.666 193.289 161.693 189.74H145.567C145.541 193.318 145.987 197.981 147.157 200.415C148.478 203.16 151.717 204.979 151.717 205.935C151.717 206.89 148.278 209.103 146.849 212.44ZM146.492 223.333C146.587 219.229 146.987 214.44 147.685 212.803C148.449 211.011 149.908 209.51 150.97 208.415C152.002 207.347 152.629 206.705 152.629 205.935C152.629 205.111 151.934 204.46 150.878 203.478C149.878 202.548 148.636 201.388 147.977 200.015C146.993 197.971 146.531 194.003 146.482 190.66H160.768C160.676 193.977 160.211 197.905 159.132 199.899C158.326 201.394 157.146 202.611 156.198 203.59C155.222 204.599 154.635 205.207 154.635 205.935C154.635 206.662 155.185 207.162 156.185 208.111C157.316 209.185 158.867 210.657 159.65 212.522C160.46 214.454 160.765 219.824 160.788 223.333H146.498H146.492Z",
    fill: "url(#paint35_linear_10322_11572)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M160.781 223.332C160.758 219.82 160.453 214.45 159.644 212.522C158.86 210.657 157.313 209.185 156.179 208.11C155.179 207.161 154.628 206.639 154.628 205.934C154.628 205.23 155.218 204.598 156.192 203.59C157.139 202.611 158.319 201.394 159.126 199.899C160.204 197.902 160.673 193.976 160.762 190.659H146.475C146.525 194.003 146.987 197.971 147.97 200.015C148.629 201.387 149.872 202.548 150.871 203.48C151.927 204.463 152.622 205.114 152.622 205.938C152.622 206.761 151.996 207.353 150.963 208.418C149.901 209.512 148.442 211.014 147.679 212.806C146.98 214.443 146.58 219.232 146.485 223.336H160.775L160.781 223.332Z",
    fill: "url(#paint36_linear_10322_11572)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M145.495 226.997H161.761C162.08 226.997 162.338 226.736 162.338 226.415V223.912C162.338 223.59 162.08 223.33 161.761 223.33H145.495C145.177 223.33 144.918 223.59 144.918 223.912V226.415C144.918 226.736 145.177 226.997 145.495 226.997Z",
    fill: "url(#paint37_linear_10322_11572)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M145.495 190.679H161.761C162.08 190.679 162.338 190.418 162.338 190.097V187.593C162.338 187.272 162.08 187.011 161.761 187.011H145.495C145.177 187.011 144.918 187.272 144.918 187.593V190.097C144.918 190.418 145.177 190.679 145.495 190.679Z",
    fill: "url(#paint38_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M145.469 223.333H151.763V223.984C151.763 224.322 152.009 224.593 152.314 224.593H162.338V226.389C162.338 226.726 162.092 226.997 161.787 226.997H145.469C145.164 226.997 144.918 226.723 144.918 226.389V223.941C144.918 223.604 145.164 223.333 145.469 223.333Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M145.469 187.012H161.787C162.092 187.012 162.338 187.286 162.338 187.62V189.38H152.314C152.009 189.38 151.763 189.654 151.763 189.988V190.676H145.469C145.164 190.676 144.918 190.401 144.918 190.067V187.62C144.918 187.283 145.164 187.012 145.469 187.012Z",
    fill: "#463332"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M144.522 226.997H162.735C162.974 226.997 163.168 226.802 163.168 226.561V225.559C163.168 225.317 162.974 225.122 162.735 225.122H144.522C144.283 225.122 144.089 225.317 144.089 225.559V226.561C144.089 226.802 144.283 226.997 144.522 226.997Z",
    fill: "url(#paint39_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M144.502 225.125H151.347C151.117 225.125 150.934 225.33 150.934 225.581V226.544C150.934 226.795 151.117 227 151.347 227H144.502C144.273 227 144.089 226.795 144.089 226.544V225.581C144.089 225.33 144.273 225.125 144.502 225.125Z",
    fill: "#463332"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M144.522 188.887H162.735C162.974 188.887 163.168 188.691 163.168 188.45V187.448C163.168 187.207 162.974 187.012 162.735 187.012H144.522C144.283 187.012 144.089 187.207 144.089 187.448V188.45C144.089 188.691 144.283 188.887 144.522 188.887Z",
    fill: "url(#paint40_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M151.717 205.931C151.717 204.975 148.478 203.156 147.157 200.411C145.984 197.977 145.538 193.315 145.567 189.736H161.692C161.686 190.487 161.663 191.287 161.614 192.104H151.583C151.583 192.104 151.081 198.077 152.265 201.651C153.1 204.175 153.553 205.107 153.553 206.235C153.553 207.363 150.976 209.069 151.291 224.245H145.567C145.607 221.004 145.908 214.638 146.852 212.436C148.278 209.096 151.72 206.883 151.72 205.931H151.717Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M144.502 187.012H151.347C151.117 187.012 150.934 187.217 150.934 187.468V188.43C150.934 188.682 151.117 188.887 151.347 188.887H144.502C144.273 188.887 144.089 188.682 144.089 188.43V187.468C144.089 187.217 144.273 187.012 144.502 187.012Z",
    fill: "#463332"
  }))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M150.875 203.477C149.875 202.548 148.633 201.387 147.974 200.015C147.564 199.162 147.246 197.958 147.01 196.615H160.162C159.909 197.918 159.572 199.076 159.129 199.899C158.323 201.394 157.143 202.611 156.195 203.59C155.218 204.598 154.422 205.359 154.078 205.875C153.642 206.526 153.51 206.467 153.133 205.875C152.812 205.369 151.927 204.463 150.875 203.481V203.477Z",
    fill: "url(#paint41_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M147.154 197.339C147.105 197.101 147.056 196.863 147.01 196.615H160.162C160.113 196.863 160.06 197.105 160.004 197.339H147.154Z",
    fill: "#FFE675"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M160.627 218.918C160.67 219.738 160.774 222.027 160.781 223.333H146.492C146.524 221.888 146.613 220.049 146.708 218.918C149.881 218.878 151.812 216.931 153.572 216.931C155.333 216.931 157.66 218.935 160.627 218.918Z",
    fill: "url(#paint42_linear_10322_11572)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M153.311 217.397C151.557 217.397 149.088 219.305 146.705 218.918C149.537 218.981 151.809 216.931 153.57 216.931C155.33 216.931 157.657 218.935 160.624 218.918C160.631 219.054 160.641 219.239 160.65 219.441C157.572 219.401 155.146 217.394 153.311 217.394V217.397Z",
    fill: "#FFE675"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M149 196.615C149.173 197.339 149.373 197.988 149.619 198.494C152.038 203.524 156.307 204.403 159.549 198.391C159.736 198.044 159.899 197.627 160.047 197.168C159.811 198.239 159.513 199.195 159.132 199.899C158.326 201.394 157.146 202.611 156.198 203.59C155.222 204.598 154.425 205.359 154.081 205.875C153.645 206.526 153.514 206.467 153.137 205.875C152.815 205.369 151.934 204.463 150.878 203.481C149.878 202.551 148.636 201.391 147.977 200.018C147.567 199.165 147.249 197.961 147.013 196.619H149.003L149 196.615Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M146.705 218.918C149.472 218.931 151.56 217.172 153.232 216.957C152.301 217.337 151.694 217.853 151.694 218.551C151.694 219.993 153.956 220.74 156.33 220.74C158.962 220.74 160.516 219.781 160.598 218.895C160.608 218.895 160.614 218.895 160.624 218.895C160.667 219.722 160.771 222.02 160.778 223.33H146.489C146.521 221.878 146.63 220.003 146.705 218.915V218.918Z",
    fill: "#AA2424"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M153.628 208.223C153.864 208.223 154.054 208.031 154.054 207.793C154.054 207.556 153.864 207.363 153.628 207.363C153.393 207.363 153.202 207.556 153.202 207.793C153.202 208.031 153.393 208.223 153.628 208.223Z",
    fill: "#ED9C47"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M153.488 216.246C153.723 216.246 153.914 216.053 153.914 215.816C153.914 215.578 153.723 215.386 153.488 215.386C153.252 215.386 153.062 215.578 153.062 215.816C153.062 216.053 153.252 216.246 153.488 216.246Z",
    fill: "#ED9C47"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M152.871 210.833C152.871 211.001 153.005 211.137 153.173 211.137C153.34 211.137 153.474 211.001 153.474 210.833C153.474 210.664 153.34 210.528 153.173 210.528C153.005 210.528 152.871 210.664 152.871 210.833Z",
    fill: "#ED9C47"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M154.11 209.256C154.11 209.381 154.212 209.484 154.336 209.484C154.461 209.484 154.563 209.381 154.563 209.256C154.563 209.13 154.461 209.027 154.336 209.027C154.212 209.027 154.11 209.13 154.11 209.256Z",
    fill: "#ED9C47"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M153.428 214.668C153.553 214.668 153.655 214.566 153.655 214.44C153.655 214.314 153.553 214.212 153.428 214.212C153.303 214.212 153.202 214.314 153.202 214.44C153.202 214.566 153.303 214.668 153.428 214.668Z",
    fill: "#ED9C47"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M152.491 216.56C152.491 216.686 152.592 216.788 152.717 216.788C152.842 216.788 152.943 216.686 152.943 216.56C152.943 216.435 152.842 216.332 152.717 216.332C152.592 216.332 152.491 216.435 152.491 216.56Z",
    fill: "#ED9C47"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M154.31 216.702C154.31 216.827 154.412 216.93 154.536 216.93C154.661 216.93 154.763 216.827 154.763 216.702C154.763 216.576 154.661 216.474 154.536 216.474C154.412 216.474 154.31 216.576 154.31 216.702Z",
    fill: "#ED9C47"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M153.002 208.769C153.127 208.769 153.228 208.667 153.228 208.541C153.228 208.415 153.127 208.312 153.002 208.312C152.877 208.312 152.776 208.415 152.776 208.541C152.776 208.667 152.877 208.769 153.002 208.769Z",
    fill: "#ED9C47"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M153.373 211.663C153.373 211.788 153.474 211.891 153.599 211.891C153.724 211.891 153.825 211.788 153.825 211.663C153.825 211.537 153.724 211.435 153.599 211.435C153.474 211.435 153.373 211.537 153.373 211.663Z",
    fill: "#ED9C47"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M153.602 207.366C153.425 207.406 153.294 207.561 153.294 207.753C153.294 207.971 153.471 208.15 153.687 208.15C153.835 208.15 153.966 208.067 154.031 207.945C153.972 208.11 153.815 208.226 153.631 208.226C153.395 208.226 153.205 208.034 153.205 207.796C153.205 207.568 153.382 207.383 153.605 207.366H153.602Z",
    fill: "#AA2424"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M153.34 215.412C153.235 215.482 153.166 215.604 153.166 215.739C153.166 215.958 153.343 216.136 153.559 216.136C153.7 216.136 153.821 216.064 153.89 215.951C153.835 216.123 153.674 216.245 153.487 216.245C153.251 216.245 153.061 216.054 153.061 215.816C153.061 215.63 153.179 215.472 153.343 215.412H153.34Z",
    fill: "#AA2424"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M153.117 210.531C153.018 210.574 152.95 210.673 152.95 210.786C152.95 210.941 153.074 211.067 153.228 211.067C153.317 211.067 153.395 211.024 153.445 210.961C153.395 211.064 153.294 211.136 153.172 211.136C153.005 211.136 152.871 211.001 152.871 210.832C152.871 210.683 152.976 210.561 153.117 210.535V210.531Z",
    fill: "#AA2424"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M154.304 209.029C154.232 209.062 154.182 209.135 154.182 209.221C154.182 209.337 154.277 209.433 154.392 209.433C154.448 209.433 154.494 209.413 154.533 209.377C154.494 209.443 154.422 209.486 154.34 209.486C154.215 209.486 154.114 209.383 154.114 209.257C154.114 209.142 154.195 209.049 154.304 209.033V209.029Z",
    fill: "#AA2424"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M153.35 214.225C153.297 214.264 153.264 214.324 153.264 214.393C153.264 214.509 153.359 214.605 153.474 214.605C153.543 214.605 153.602 214.572 153.641 214.519C153.609 214.605 153.527 214.668 153.428 214.668C153.304 214.668 153.202 214.565 153.202 214.44C153.202 214.34 153.264 214.258 153.35 214.225Z",
    fill: "#AA2424"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M152.638 216.345C152.596 216.384 152.569 216.437 152.569 216.5C152.569 216.616 152.664 216.712 152.779 216.712C152.838 216.712 152.894 216.685 152.93 216.646C152.897 216.728 152.815 216.788 152.72 216.788C152.596 216.788 152.494 216.685 152.494 216.56C152.494 216.464 152.553 216.381 152.638 216.348V216.345Z",
    fill: "#AA2424"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M154.428 216.504C154.392 216.54 154.369 216.593 154.369 216.649C154.369 216.765 154.464 216.861 154.579 216.861C154.654 216.861 154.72 216.821 154.756 216.759C154.73 216.858 154.641 216.934 154.536 216.934C154.412 216.934 154.31 216.831 154.31 216.706C154.31 216.62 154.359 216.544 154.428 216.504Z",
    fill: "#AA2424"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M152.963 208.315C152.894 208.348 152.848 208.421 152.848 208.504C152.848 208.62 152.943 208.716 153.058 208.716C153.113 208.716 153.163 208.692 153.199 208.659C153.159 208.726 153.087 208.772 153.005 208.772C152.881 208.772 152.779 208.669 152.779 208.544C152.779 208.431 152.861 208.339 152.966 208.319L152.963 208.315Z",
    fill: "#AA2424"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M153.481 211.467C153.451 211.503 153.432 211.549 153.432 211.602C153.432 211.718 153.527 211.814 153.642 211.814C153.72 211.814 153.786 211.771 153.822 211.708C153.802 211.814 153.71 211.893 153.599 211.893C153.474 211.893 153.373 211.791 153.373 211.665C153.373 211.583 153.419 211.51 153.484 211.47L153.481 211.467Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M155.503 209.886C153.189 210.928 157.359 215.349 158.605 214.837C160.535 214.043 157.523 208.977 155.503 209.886Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M162.253 225.859C162.257 226.527 153.324 226.18 153.32 225.82C153.32 225.459 162.247 225.191 162.253 225.859Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M162.253 187.822C162.257 188.49 153.324 188.143 153.32 187.783C153.32 187.422 162.247 187.154 162.253 187.822Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M158.503 192.865C155.979 192.647 156.313 198.596 157.595 199.013C159.306 199.572 160.555 193.044 158.503 192.865Z",
    fill: "#FFF7E6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M157.11 199.811C155.894 199.033 154.222 202.529 154.828 202.87C155.766 203.399 158.064 200.422 157.11 199.811Z",
    fill: "#FFF7E6"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7 76.24C31.2867 76.24 30.0733 75.94 29.06 75.34C28.0467 74.7267 27.2667 73.88 26.72 72.8C26.1733 71.7067 25.9 70.4467 25.9 69.02C25.9 67.5933 26.1733 66.3333 26.72 65.24C27.2667 64.1467 28.0467 63.2933 29.06 62.68C30.0733 62.0667 31.2867 61.76 32.7 61.76C34.38 61.76 35.7533 62.18 36.82 63.02C37.9 63.8467 38.5733 65.0133 38.84 66.52H36.02C35.8467 65.76 35.4733 65.1667 34.9 64.74C34.34 64.3 33.5933 64.08 32.66 64.08C31.3667 64.08 30.3533 64.52 29.62 65.4C28.8867 66.28 28.52 67.4867 28.52 69.02C28.52 70.5533 28.8867 71.76 29.62 72.64C30.3533 73.5067 31.3667 73.94 32.66 73.94C33.5933 73.94 34.34 73.74 34.9 73.34C35.4733 72.9267 35.8467 72.36 36.02 71.64H38.84C38.5733 73.08 37.9 74.2067 36.82 75.02C35.7533 75.8333 34.38 76.24 32.7 76.24ZM44.5461 76.24C43.3061 76.24 42.3461 75.8533 41.6661 75.08C40.9994 74.3067 40.6661 73.1733 40.6661 71.68V66.08H43.2061V71.44C43.2061 72.2933 43.3794 72.9467 43.7261 73.4C44.0728 73.8533 44.6194 74.08 45.3661 74.08C46.0728 74.08 46.6528 73.8267 47.1061 73.32C47.5728 72.8133 47.8061 72.1067 47.8061 71.2V66.08H50.3661V76H48.1061L47.9061 74.32C47.5994 74.9067 47.1528 75.3733 46.5661 75.72C45.9928 76.0667 45.3194 76.24 44.5461 76.24ZM52.7741 76V66.08H55.0541L55.2941 67.94C55.6541 67.3 56.1407 66.7933 56.7541 66.42C57.3807 66.0333 58.1141 65.84 58.9541 65.84V68.54H58.2341C57.6741 68.54 57.1741 68.6267 56.7341 68.8C56.2941 68.9733 55.9474 69.2733 55.6941 69.7C55.4541 70.1267 55.3341 70.72 55.3341 71.48V76H52.7741ZM60.4838 76V66.08H62.7638L63.0038 67.94C63.3638 67.3 63.8504 66.7933 64.4638 66.42C65.0904 66.0333 65.8238 65.84 66.6638 65.84V68.54H65.9438C65.3838 68.54 64.8838 68.6267 64.4438 68.8C64.0038 68.9733 63.6571 69.2733 63.4038 69.7C63.1638 70.1267 63.0438 70.72 63.0438 71.48V76H60.4838ZM69.5734 64.54C69.1068 64.54 68.7201 64.4 68.4134 64.12C68.1201 63.84 67.9734 63.4867 67.9734 63.06C67.9734 62.6333 68.1201 62.2867 68.4134 62.02C68.7201 61.74 69.1068 61.6 69.5734 61.6C70.0401 61.6 70.4201 61.74 70.7134 62.02C71.0201 62.2867 71.1734 62.6333 71.1734 63.06C71.1734 63.4867 71.0201 63.84 70.7134 64.12C70.4201 64.4 70.0401 64.54 69.5734 64.54ZM68.2934 76V66.08H70.8534V76H68.2934ZM78.1655 76.24C77.1521 76.24 76.2588 76.02 75.4855 75.58C74.7121 75.14 74.0988 74.5267 73.6455 73.74C73.2055 72.9533 72.9855 72.0533 72.9855 71.04C72.9855 70.0267 73.2055 69.1267 73.6455 68.34C74.0988 67.5533 74.7121 66.94 75.4855 66.5C76.2588 66.06 77.1521 65.84 78.1655 65.84C79.4321 65.84 80.4988 66.1733 81.3655 66.84C82.2321 67.4933 82.7855 68.4 83.0255 69.56H80.3255C80.1921 69.08 79.9255 68.7067 79.5255 68.44C79.1388 68.16 78.6788 68.02 78.1455 68.02C77.4388 68.02 76.8388 68.2867 76.3455 68.82C75.8521 69.3533 75.6055 70.0933 75.6055 71.04C75.6055 71.9867 75.8521 72.7267 76.3455 73.26C76.8388 73.7933 77.4388 74.06 78.1455 74.06C78.6788 74.06 79.1388 73.9267 79.5255 73.66C79.9255 73.3933 80.1921 73.0133 80.3255 72.52H83.0255C82.7855 73.64 82.2321 74.54 81.3655 75.22C80.4988 75.9 79.4321 76.24 78.1655 76.24ZM88.7977 76.24C87.5577 76.24 86.5977 75.8533 85.9177 75.08C85.251 74.3067 84.9177 73.1733 84.9177 71.68V66.08H87.4577V71.44C87.4577 72.2933 87.631 72.9467 87.9777 73.4C88.3243 73.8533 88.871 74.08 89.6177 74.08C90.3243 74.08 90.9043 73.8267 91.3577 73.32C91.8243 72.8133 92.0577 72.1067 92.0577 71.2V66.08H94.6177V76H92.3577L92.1577 74.32C91.851 74.9067 91.4043 75.3733 90.8177 75.72C90.2443 76.0667 89.571 76.24 88.7977 76.24ZM97.0256 76V61.6H99.5856V76H97.0256ZM105.701 76.24C104.461 76.24 103.501 75.8533 102.821 75.08C102.155 74.3067 101.821 73.1733 101.821 71.68V66.08H104.361V71.44C104.361 72.2933 104.535 72.9467 104.881 73.4C105.228 73.8533 105.775 74.08 106.521 74.08C107.228 74.08 107.808 73.8267 108.261 73.32C108.728 72.8133 108.961 72.1067 108.961 71.2V66.08H111.521V76H109.261L109.061 74.32C108.755 74.9067 108.308 75.3733 107.721 75.72C107.148 76.0667 106.475 76.24 105.701 76.24ZM113.929 76V66.08H116.189L116.409 67.42C116.729 66.94 117.149 66.56 117.669 66.28C118.203 65.9867 118.816 65.84 119.509 65.84C121.043 65.84 122.129 66.4333 122.769 67.62C123.129 67.0733 123.609 66.64 124.209 66.32C124.823 66 125.489 65.84 126.209 65.84C127.503 65.84 128.496 66.2267 129.189 67C129.883 67.7733 130.229 68.9067 130.229 70.4V76H127.669V70.64C127.669 69.7867 127.503 69.1333 127.169 68.68C126.849 68.2267 126.349 68 125.669 68C124.976 68 124.416 68.2533 123.989 68.76C123.576 69.2667 123.369 69.9733 123.369 70.88V76H120.809V70.64C120.809 69.7867 120.643 69.1333 120.309 68.68C119.976 68.2267 119.463 68 118.769 68C118.089 68 117.536 68.2533 117.109 68.76C116.696 69.2667 116.489 69.9733 116.489 70.88V76H113.929ZM141.525 76.22C140.499 76.22 139.605 76.0467 138.845 75.7C138.085 75.34 137.492 74.84 137.065 74.2C136.652 73.56 136.445 72.8133 136.445 71.96C136.445 71.0533 136.699 70.2333 137.205 69.5C137.712 68.7667 138.465 68.18 139.465 67.74C139.065 67.2733 138.779 66.8333 138.605 66.42C138.432 66.0067 138.345 65.5667 138.345 65.1C138.345 64.46 138.505 63.8933 138.825 63.4C139.145 62.8933 139.599 62.4933 140.185 62.2C140.785 61.9067 141.499 61.76 142.325 61.76C143.165 61.76 143.879 61.9133 144.465 62.22C145.052 62.5267 145.492 62.94 145.785 63.46C146.092 63.98 146.232 64.56 146.205 65.2H143.765C143.765 64.7067 143.619 64.34 143.325 64.1C143.045 63.8467 142.705 63.72 142.305 63.72C141.852 63.72 141.485 63.8467 141.205 64.1C140.939 64.3533 140.805 64.68 140.805 65.08C140.805 65.4133 140.912 65.7533 141.125 66.1C141.339 66.4467 141.652 66.8467 142.065 67.3L145.985 71.18C146.265 70.7267 146.559 70.2 146.865 69.6L147.305 68.72H149.925L149.225 70.08C148.692 71.16 148.159 72.0733 147.625 72.82L150.845 76H147.785L146.225 74.44C145.545 75.0667 144.819 75.52 144.045 75.8C143.285 76.08 142.445 76.22 141.525 76.22ZM138.925 71.8C138.925 72.4533 139.165 73.0067 139.645 73.46C140.139 73.9 140.792 74.12 141.605 74.12C142.765 74.12 143.772 73.7067 144.625 72.88L140.925 69.22C140.245 69.5133 139.739 69.88 139.405 70.32C139.085 70.76 138.925 71.2533 138.925 71.8ZM26.36 102V88H31.54C32.66 88 33.5867 88.1867 34.32 88.56C35.0533 88.9333 35.6 89.4467 35.96 90.1C36.32 90.7533 36.5 91.4867 36.5 92.3C36.5 93.0733 36.3267 93.7867 35.98 94.44C35.6333 95.08 35.0933 95.6 34.36 96C33.6267 96.3867 32.6867 96.58 31.54 96.58H28.92V102H26.36ZM28.92 94.5H31.38C32.2733 94.5 32.9133 94.3067 33.3 93.92C33.7 93.52 33.9 92.98 33.9 92.3C33.9 91.6067 33.7 91.0667 33.3 90.68C32.9133 90.28 32.2733 90.08 31.38 90.08H28.92V94.5ZM42.5406 102.24C41.5406 102.24 40.654 102.027 39.8806 101.6C39.1073 101.173 38.5006 100.573 38.0606 99.8C37.6206 99.0267 37.4006 98.1333 37.4006 97.12C37.4006 96.0933 37.614 95.18 38.0406 94.38C38.4806 93.58 39.0806 92.96 39.8406 92.52C40.614 92.0667 41.5206 91.84 42.5606 91.84C43.534 91.84 44.394 92.0533 45.1406 92.48C45.8873 92.9067 46.4673 93.4933 46.8806 94.24C47.3073 94.9733 47.5206 95.7933 47.5206 96.7C47.5206 96.8467 47.514 97 47.5006 97.16C47.5006 97.32 47.494 97.4867 47.4806 97.66H39.9406C39.994 98.4333 40.2606 99.04 40.7406 99.48C41.234 99.92 41.8273 100.14 42.5206 100.14C43.0406 100.14 43.474 100.027 43.8206 99.8C44.1806 99.56 44.4473 99.2533 44.6206 98.88H47.2206C47.034 99.5067 46.7206 100.08 46.2806 100.6C45.854 101.107 45.3206 101.507 44.6806 101.8C44.054 102.093 43.3406 102.24 42.5406 102.24ZM42.5606 93.92C41.934 93.92 41.3806 94.1 40.9006 94.46C40.4206 94.8067 40.114 95.34 39.9806 96.06H44.9206C44.8806 95.4067 44.6406 94.8867 44.2006 94.5C43.7606 94.1133 43.214 93.92 42.5606 93.92ZM54.0137 102.24C53.0804 102.24 52.2471 102.013 51.5137 101.56C50.7804 101.107 50.2004 100.487 49.7737 99.7C49.3471 98.9133 49.1337 98.02 49.1337 97.02C49.1337 96.02 49.3471 95.1333 49.7737 94.36C50.2004 93.5733 50.7804 92.96 51.5137 92.52C52.2471 92.0667 53.0804 91.84 54.0137 91.84C54.7604 91.84 55.4137 91.98 55.9738 92.26C56.5338 92.54 56.9871 92.9333 57.3337 93.44V87.6H59.8937V102H57.6137L57.3337 100.58C57.0138 101.02 56.5871 101.407 56.0537 101.74C55.5337 102.073 54.8537 102.24 54.0137 102.24ZM54.5537 100C55.3804 100 56.0538 99.7267 56.5738 99.18C57.1071 98.62 57.3737 97.9067 57.3737 97.04C57.3737 96.1733 57.1071 95.4667 56.5738 94.92C56.0538 94.36 55.3804 94.08 54.5537 94.08C53.7404 94.08 53.0671 94.3533 52.5337 94.9C52.0004 95.4467 51.7337 96.1533 51.7337 97.02C51.7337 97.8867 52.0004 98.6 52.5337 99.16C53.0671 99.72 53.7404 100 54.5537 100ZM65.7006 102.24C64.8473 102.24 64.1473 102.107 63.6006 101.84C63.054 101.56 62.6473 101.193 62.3806 100.74C62.114 100.287 61.9806 99.7867 61.9806 99.24C61.9806 98.32 62.3406 97.5733 63.0606 97C63.7806 96.4267 64.8606 96.14 66.3006 96.14H68.8206V95.9C68.8206 95.22 68.6273 94.72 68.2406 94.4C67.854 94.08 67.374 93.92 66.8006 93.92C66.2806 93.92 65.8273 94.0467 65.4406 94.3C65.054 94.54 64.814 94.9 64.7206 95.38H62.2206C62.2873 94.66 62.5273 94.0333 62.9406 93.5C63.3673 92.9667 63.914 92.56 64.5806 92.28C65.2473 91.9867 65.994 91.84 66.8206 91.84C68.234 91.84 69.3473 92.1933 70.1606 92.9C70.974 93.6067 71.3806 94.6067 71.3806 95.9V102H69.2006L68.9606 100.4C68.6673 100.933 68.254 101.373 67.7206 101.72C67.2006 102.067 66.5273 102.24 65.7006 102.24ZM66.2806 100.24C67.014 100.24 67.5806 100 67.9806 99.52C68.394 99.04 68.654 98.4467 68.7606 97.74H66.5806C65.9006 97.74 65.414 97.8667 65.1206 98.12C64.8273 98.36 64.6806 98.66 64.6806 99.02C64.6806 99.4067 64.8273 99.7067 65.1206 99.92C65.414 100.133 65.8006 100.24 66.2806 100.24ZM77.8036 99.04C77.3236 99.04 76.8769 98.9867 76.4636 98.88L75.7236 99.62C75.9503 99.74 76.2569 99.84 76.6436 99.92C77.0303 100 77.6569 100.08 78.5236 100.16C79.8436 100.28 80.8036 100.593 81.4036 101.1C82.0036 101.607 82.3036 102.307 82.3036 103.2C82.3036 103.787 82.1436 104.34 81.8236 104.86C81.5036 105.393 81.0103 105.82 80.3436 106.14C79.6769 106.473 78.8236 106.64 77.7836 106.64C76.3703 106.64 75.2303 106.373 74.3636 105.84C73.4969 105.32 73.0636 104.533 73.0636 103.48C73.0636 102.587 73.4969 101.813 74.3636 101.16C74.0969 101.04 73.8636 100.913 73.6636 100.78C73.4769 100.647 73.3103 100.507 73.1636 100.36V99.9L74.9036 98.06C74.1303 97.38 73.7436 96.5067 73.7436 95.44C73.7436 94.7733 73.9036 94.1667 74.2236 93.62C74.5569 93.0733 75.0236 92.64 75.6236 92.32C76.2236 92 76.9503 91.84 77.8036 91.84C78.3636 91.84 78.8836 91.92 79.3636 92.08H83.1236V93.64L81.4236 93.76C81.6903 94.2667 81.8236 94.8267 81.8236 95.44C81.8236 96.1067 81.6636 96.7133 81.3436 97.26C81.0236 97.8067 80.5569 98.24 79.9436 98.56C79.3436 98.88 78.6303 99.04 77.8036 99.04ZM77.8036 97.08C78.3236 97.08 78.7503 96.94 79.0836 96.66C79.4303 96.38 79.6036 95.98 79.6036 95.46C79.6036 94.94 79.4303 94.54 79.0836 94.26C78.7503 93.98 78.3236 93.84 77.8036 93.84C77.2569 93.84 76.8169 93.98 76.4836 94.26C76.1503 94.54 75.9836 94.94 75.9836 95.46C75.9836 95.98 76.1503 96.38 76.4836 96.66C76.8169 96.94 77.2569 97.08 77.8036 97.08ZM75.4036 103.22C75.4036 103.713 75.6303 104.08 76.0836 104.32C76.5503 104.573 77.1169 104.7 77.7836 104.7C78.4236 104.7 78.9436 104.567 79.3436 104.3C79.7436 104.047 79.9436 103.7 79.9436 103.26C79.9436 102.9 79.8103 102.6 79.5436 102.36C79.2903 102.12 78.7769 101.973 78.0036 101.92C77.4569 101.88 76.9503 101.82 76.4836 101.74C76.0969 101.953 75.8169 102.187 75.6436 102.44C75.4836 102.693 75.4036 102.953 75.4036 103.22ZM89.1397 102.24C88.1797 102.24 87.313 102.02 86.5397 101.58C85.7797 101.14 85.173 100.533 84.7197 99.76C84.2797 98.9733 84.0597 98.0667 84.0597 97.04C84.0597 96.0133 84.2864 95.1133 84.7397 94.34C85.193 93.5533 85.7997 92.94 86.5597 92.5C87.333 92.06 88.1997 91.84 89.1597 91.84C90.1064 91.84 90.9597 92.06 91.7197 92.5C92.493 92.94 93.0997 93.5533 93.5397 94.34C93.993 95.1133 94.2197 96.0133 94.2197 97.04C94.2197 98.0667 93.993 98.9733 93.5397 99.76C93.0997 100.533 92.493 101.14 91.7197 101.58C90.9464 102.02 90.0864 102.24 89.1397 102.24ZM89.1397 100.02C89.8064 100.02 90.3864 99.7733 90.8797 99.28C91.373 98.7733 91.6197 98.0267 91.6197 97.04C91.6197 96.0533 91.373 95.3133 90.8797 94.82C90.3864 94.3133 89.813 94.06 89.1597 94.06C88.4797 94.06 87.893 94.3133 87.3997 94.82C86.9197 95.3133 86.6797 96.0533 86.6797 97.04C86.6797 98.0267 86.9197 98.7733 87.3997 99.28C87.893 99.7733 88.473 100.02 89.1397 100.02ZM99.8636 99.04C99.3836 99.04 98.9369 98.9867 98.5236 98.88L97.7836 99.62C98.0103 99.74 98.3169 99.84 98.7036 99.92C99.0903 100 99.7169 100.08 100.584 100.16C101.904 100.28 102.864 100.593 103.464 101.1C104.064 101.607 104.364 102.307 104.364 103.2C104.364 103.787 104.204 104.34 103.884 104.86C103.564 105.393 103.07 105.82 102.404 106.14C101.737 106.473 100.884 106.64 99.8436 106.64C98.4303 106.64 97.2903 106.373 96.4236 105.84C95.5569 105.32 95.1236 104.533 95.1236 103.48C95.1236 102.587 95.5569 101.813 96.4236 101.16C96.1569 101.04 95.9236 100.913 95.7236 100.78C95.5369 100.647 95.3703 100.507 95.2236 100.36V99.9L96.9636 98.06C96.1903 97.38 95.8036 96.5067 95.8036 95.44C95.8036 94.7733 95.9636 94.1667 96.2836 93.62C96.6169 93.0733 97.0836 92.64 97.6836 92.32C98.2836 92 99.0103 91.84 99.8636 91.84C100.424 91.84 100.944 91.92 101.424 92.08H105.184V93.64L103.484 93.76C103.75 94.2667 103.884 94.8267 103.884 95.44C103.884 96.1067 103.724 96.7133 103.404 97.26C103.084 97.8067 102.617 98.24 102.004 98.56C101.404 98.88 100.69 99.04 99.8636 99.04ZM99.8636 97.08C100.384 97.08 100.81 96.94 101.144 96.66C101.49 96.38 101.664 95.98 101.664 95.46C101.664 94.94 101.49 94.54 101.144 94.26C100.81 93.98 100.384 93.84 99.8636 93.84C99.3169 93.84 98.8769 93.98 98.5436 94.26C98.2103 94.54 98.0436 94.94 98.0436 95.46C98.0436 95.98 98.2103 96.38 98.5436 96.66C98.8769 96.94 99.3169 97.08 99.8636 97.08ZM97.4636 103.22C97.4636 103.713 97.6903 104.08 98.1436 104.32C98.6103 104.573 99.1769 104.7 99.8436 104.7C100.484 104.7 101.004 104.567 101.404 104.3C101.804 104.047 102.004 103.7 102.004 103.26C102.004 102.9 101.87 102.6 101.604 102.36C101.35 102.12 100.837 101.973 100.064 101.92C99.5169 101.88 99.0103 101.82 98.5436 101.74C98.1569 101.953 97.8769 102.187 97.7036 102.44C97.5436 102.693 97.4636 102.953 97.4636 103.22ZM108.07 106.4L110.37 101.34H109.77L105.91 92.08H108.69L111.47 99.06L114.37 92.08H117.09L110.79 106.4H108.07Z",
    fill: "#FFB900"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M25.612 53V46.7H26.764V53H25.612ZM27.859 53V48.536H28.876L28.966 49.292C29.104 49.028 29.302 48.818 29.56 48.662C29.824 48.506 30.133 48.428 30.487 48.428C31.039 48.428 31.468 48.602 31.774 48.95C32.08 49.298 32.233 49.808 32.233 50.48V53H31.081V50.588C31.081 50.204 31.003 49.91 30.847 49.706C30.691 49.502 30.448 49.4 30.118 49.4C29.794 49.4 29.527 49.514 29.317 49.742C29.113 49.97 29.011 50.288 29.011 50.696V53H27.859ZM35.2246 53C34.7566 53 34.3816 52.886 34.0996 52.658C33.8176 52.43 33.6766 52.025 33.6766 51.443V49.499H32.9116V48.536H33.6766L33.8116 47.339H34.8286V48.536H36.0346V49.499H34.8286V51.452C34.8286 51.668 34.8736 51.818 34.9636 51.902C35.0596 51.98 35.2216 52.019 35.4496 52.019H36.0076V53H35.2246ZM38.9795 53.108C38.5295 53.108 38.1305 53.012 37.7825 52.82C37.4345 52.628 37.1615 52.358 36.9635 52.01C36.7655 51.662 36.6665 51.26 36.6665 50.804C36.6665 50.342 36.7625 49.931 36.9545 49.571C37.1525 49.211 37.4225 48.932 37.7645 48.734C38.1125 48.53 38.5205 48.428 38.9885 48.428C39.4265 48.428 39.8135 48.524 40.1495 48.716C40.4855 48.908 40.7465 49.172 40.9325 49.508C41.1245 49.838 41.2205 50.207 41.2205 50.615C41.2205 50.681 41.2175 50.75 41.2115 50.822C41.2115 50.894 41.2085 50.969 41.2025 51.047H37.8095C37.8335 51.395 37.9535 51.668 38.1695 51.866C38.3915 52.064 38.6585 52.163 38.9705 52.163C39.2045 52.163 39.3995 52.112 39.5555 52.01C39.7175 51.902 39.8375 51.764 39.9155 51.596H41.0855C41.0015 51.878 40.8605 52.136 40.6625 52.37C40.4705 52.598 40.2305 52.778 39.9425 52.91C39.6605 53.042 39.3395 53.108 38.9795 53.108ZM38.9885 49.364C38.7065 49.364 38.4575 49.445 38.2415 49.607C38.0255 49.763 37.8875 50.003 37.8275 50.327H40.0505C40.0325 50.033 39.9245 49.799 39.7265 49.625C39.5285 49.451 39.2825 49.364 38.9885 49.364ZM42.0904 53V48.536H43.1164L43.2244 49.373C43.3864 49.085 43.6054 48.857 43.8814 48.689C44.1634 48.515 44.4934 48.428 44.8714 48.428V49.643H44.5474C44.2954 49.643 44.0704 49.682 43.8724 49.76C43.6744 49.838 43.5184 49.973 43.4044 50.165C43.2964 50.357 43.2424 50.624 43.2424 50.966V53H42.0904ZM45.5597 53V48.536H46.5767L46.6667 49.292C46.8047 49.028 47.0027 48.818 47.2607 48.662C47.5247 48.506 47.8337 48.428 48.1877 48.428C48.7397 48.428 49.1687 48.602 49.4747 48.95C49.7807 49.298 49.9337 49.808 49.9337 50.48V53H48.7817V50.588C48.7817 50.204 48.7037 49.91 48.5477 49.706C48.3917 49.502 48.1487 49.4 47.8187 49.4C47.4947 49.4 47.2277 49.514 47.0177 49.742C46.8137 49.97 46.7117 50.288 46.7117 50.696V53H45.5597ZM52.4753 53.108C52.0913 53.108 51.7763 53.048 51.5303 52.928C51.2843 52.802 51.1013 52.637 50.9813 52.433C50.8613 52.229 50.8013 52.004 50.8013 51.758C50.8013 51.344 50.9633 51.008 51.2873 50.75C51.6113 50.492 52.0973 50.363 52.7453 50.363H53.8793V50.255C53.8793 49.949 53.7923 49.724 53.6183 49.58C53.4443 49.436 53.2283 49.364 52.9703 49.364C52.7363 49.364 52.5323 49.421 52.3583 49.535C52.1843 49.643 52.0763 49.805 52.0343 50.021H50.9093C50.9393 49.697 51.0473 49.415 51.2333 49.175C51.4253 48.935 51.6713 48.752 51.9713 48.626C52.2713 48.494 52.6073 48.428 52.9793 48.428C53.6153 48.428 54.1163 48.587 54.4823 48.905C54.8483 49.223 55.0313 49.673 55.0313 50.255V53H54.0503L53.9423 52.28C53.8103 52.52 53.6243 52.718 53.3843 52.874C53.1503 53.03 52.8473 53.108 52.4753 53.108ZM52.7363 52.208C53.0663 52.208 53.3213 52.1 53.5013 51.884C53.6873 51.668 53.8043 51.401 53.8523 51.083H52.8713C52.5653 51.083 52.3463 51.14 52.2143 51.254C52.0823 51.362 52.0163 51.497 52.0163 51.659C52.0163 51.833 52.0823 51.968 52.2143 52.064C52.3463 52.16 52.5203 52.208 52.7363 52.208ZM57.9591 53C57.4911 53 57.1161 52.886 56.8341 52.658C56.5521 52.43 56.4111 52.025 56.4111 51.443V49.499H55.6461V48.536H56.4111L56.5461 47.339H57.5631V48.536H58.7691V49.499H57.5631V51.452C57.5631 51.668 57.6081 51.818 57.6981 51.902C57.7941 51.98 57.9561 52.019 58.1841 52.019H58.7421V53H57.9591ZM60.2802 47.843C60.0702 47.843 59.8962 47.78 59.7582 47.654C59.6262 47.528 59.5602 47.369 59.5602 47.177C59.5602 46.985 59.6262 46.829 59.7582 46.709C59.8962 46.583 60.0702 46.52 60.2802 46.52C60.4902 46.52 60.6612 46.583 60.7932 46.709C60.9312 46.829 61.0002 46.985 61.0002 47.177C61.0002 47.369 60.9312 47.528 60.7932 47.654C60.6612 47.78 60.4902 47.843 60.2802 47.843ZM59.7042 53V48.536H60.8562V53H59.7042ZM64.1016 53.108C63.6696 53.108 63.2796 53.009 62.9316 52.811C62.5896 52.613 62.3166 52.34 62.1126 51.992C61.9146 51.638 61.8156 51.23 61.8156 50.768C61.8156 50.306 61.9176 49.901 62.1216 49.553C62.3256 49.199 62.5986 48.923 62.9406 48.725C63.2886 48.527 63.6786 48.428 64.1106 48.428C64.5366 48.428 64.9206 48.527 65.2626 48.725C65.6106 48.923 65.8836 49.199 66.0816 49.553C66.2856 49.901 66.3876 50.306 66.3876 50.768C66.3876 51.23 66.2856 51.638 66.0816 51.992C65.8836 52.34 65.6106 52.613 65.2626 52.811C64.9146 53.009 64.5276 53.108 64.1016 53.108ZM64.1016 52.109C64.4016 52.109 64.6626 51.998 64.8846 51.776C65.1066 51.548 65.2176 51.212 65.2176 50.768C65.2176 50.324 65.1066 49.991 64.8846 49.769C64.6626 49.541 64.4046 49.427 64.1106 49.427C63.8046 49.427 63.5406 49.541 63.3186 49.769C63.1026 49.991 62.9946 50.324 62.9946 50.768C62.9946 51.212 63.1026 51.548 63.3186 51.776C63.5406 51.998 63.8016 52.109 64.1016 52.109ZM67.3186 53V48.536H68.3356L68.4256 49.292C68.5636 49.028 68.7616 48.818 69.0196 48.662C69.2836 48.506 69.5926 48.428 69.9466 48.428C70.4986 48.428 70.9276 48.602 71.2336 48.95C71.5396 49.298 71.6926 49.808 71.6926 50.48V53H70.5406V50.588C70.5406 50.204 70.4626 49.91 70.3066 49.706C70.1506 49.502 69.9076 49.4 69.5776 49.4C69.2536 49.4 68.9866 49.514 68.7766 49.742C68.5726 49.97 68.4706 50.288 68.4706 50.696V53H67.3186ZM74.2342 53.108C73.8502 53.108 73.5352 53.048 73.2892 52.928C73.0432 52.802 72.8602 52.637 72.7402 52.433C72.6202 52.229 72.5602 52.004 72.5602 51.758C72.5602 51.344 72.7222 51.008 73.0462 50.75C73.3702 50.492 73.8562 50.363 74.5042 50.363H75.6382V50.255C75.6382 49.949 75.5512 49.724 75.3772 49.58C75.2032 49.436 74.9872 49.364 74.7292 49.364C74.4952 49.364 74.2912 49.421 74.1172 49.535C73.9432 49.643 73.8352 49.805 73.7932 50.021H72.6682C72.6982 49.697 72.8062 49.415 72.9922 49.175C73.1842 48.935 73.4302 48.752 73.7302 48.626C74.0302 48.494 74.3662 48.428 74.7382 48.428C75.3742 48.428 75.8752 48.587 76.2412 48.905C76.6072 49.223 76.7902 49.673 76.7902 50.255V53H75.8092L75.7012 52.28C75.5692 52.52 75.3832 52.718 75.1432 52.874C74.9092 53.03 74.6062 53.108 74.2342 53.108ZM74.4952 52.208C74.8252 52.208 75.0802 52.1 75.2602 51.884C75.4462 51.668 75.5632 51.401 75.6112 51.083H74.6302C74.3242 51.083 74.1052 51.14 73.9732 51.254C73.8412 51.362 73.7752 51.497 73.7752 51.659C73.7752 51.833 73.8412 51.968 73.9732 52.064C74.1052 52.16 74.2792 52.208 74.4952 52.208ZM77.7906 53V46.52H78.9426V53H77.7906ZM80.0207 53V46.52H81.1727V53H80.0207ZM82.8088 54.98L83.8438 52.703H83.5738L81.8368 48.536H83.0878L84.3388 51.677L85.6438 48.536H86.8678L84.0328 54.98H82.8088ZM89.5944 53V46.7H92.1234C92.7774 46.7 93.2754 46.853 93.6174 47.159C93.9654 47.459 94.1394 47.846 94.1394 48.32C94.1394 48.716 94.0314 49.034 93.8154 49.274C93.6054 49.508 93.3474 49.667 93.0414 49.751C93.4014 49.823 93.6984 50.003 93.9324 50.291C94.1664 50.573 94.2834 50.903 94.2834 51.281C94.2834 51.779 94.1034 52.19 93.7434 52.514C93.3834 52.838 92.8734 53 92.2134 53H89.5944ZM90.7464 49.346H91.9524C92.2764 49.346 92.5254 49.271 92.6994 49.121C92.8734 48.971 92.9604 48.758 92.9604 48.482C92.9604 48.218 92.8734 48.011 92.6994 47.861C92.5314 47.705 92.2764 47.627 91.9344 47.627H90.7464V49.346ZM90.7464 52.064H92.0334C92.3754 52.064 92.6394 51.986 92.8254 51.83C93.0174 51.668 93.1134 51.443 93.1134 51.155C93.1134 50.861 93.0144 50.63 92.8164 50.462C92.6184 50.294 92.3514 50.21 92.0154 50.21H90.7464V52.064ZM97.3151 53.108C96.8651 53.108 96.4661 53.012 96.1181 52.82C95.7701 52.628 95.4971 52.358 95.2991 52.01C95.1011 51.662 95.0021 51.26 95.0021 50.804C95.0021 50.342 95.0981 49.931 95.2901 49.571C95.4881 49.211 95.7581 48.932 96.1001 48.734C96.4481 48.53 96.8561 48.428 97.3241 48.428C97.7621 48.428 98.1491 48.524 98.4851 48.716C98.8211 48.908 99.0821 49.172 99.2681 49.508C99.4601 49.838 99.5561 50.207 99.5561 50.615C99.5561 50.681 99.5531 50.75 99.5471 50.822C99.5471 50.894 99.5441 50.969 99.5381 51.047H96.1451C96.1691 51.395 96.2891 51.668 96.5051 51.866C96.7271 52.064 96.9941 52.163 97.3061 52.163C97.5401 52.163 97.7351 52.112 97.8911 52.01C98.0531 51.902 98.1731 51.764 98.2511 51.596H99.4211C99.3371 51.878 99.1961 52.136 98.9981 52.37C98.8061 52.598 98.5661 52.778 98.2781 52.91C97.9961 53.042 97.6751 53.108 97.3151 53.108ZM97.3241 49.364C97.0421 49.364 96.7931 49.445 96.5771 49.607C96.3611 49.763 96.2231 50.003 96.1631 50.327H98.3861C98.3681 50.033 98.2601 49.799 98.0621 49.625C97.8641 49.451 97.6181 49.364 97.3241 49.364ZM100.426 53V48.536H101.443L101.533 49.292C101.671 49.028 101.869 48.818 102.127 48.662C102.391 48.506 102.7 48.428 103.054 48.428C103.606 48.428 104.035 48.602 104.341 48.95C104.647 49.298 104.8 49.808 104.8 50.48V53H103.648V50.588C103.648 50.204 103.57 49.91 103.414 49.706C103.258 49.502 103.015 49.4 102.685 49.4C102.361 49.4 102.094 49.514 101.884 49.742C101.68 49.97 101.578 50.288 101.578 50.696V53H100.426ZM107.99 53.108C107.534 53.108 107.132 53.009 106.784 52.811C106.436 52.613 106.16 52.337 105.956 51.983C105.758 51.629 105.659 51.224 105.659 50.768C105.659 50.312 105.758 49.907 105.956 49.553C106.16 49.199 106.436 48.923 106.784 48.725C107.132 48.527 107.534 48.428 107.99 48.428C108.56 48.428 109.04 48.578 109.43 48.878C109.82 49.172 110.069 49.58 110.177 50.102H108.962C108.902 49.886 108.782 49.718 108.602 49.598C108.428 49.472 108.221 49.409 107.981 49.409C107.663 49.409 107.393 49.529 107.171 49.769C106.949 50.009 106.838 50.342 106.838 50.768C106.838 51.194 106.949 51.527 107.171 51.767C107.393 52.007 107.663 52.127 107.981 52.127C108.221 52.127 108.428 52.067 108.602 51.947C108.782 51.827 108.902 51.656 108.962 51.434H110.177C110.069 51.938 109.82 52.343 109.43 52.649C109.04 52.955 108.56 53.108 107.99 53.108ZM111.1 53V46.52H112.252V49.22C112.402 48.974 112.603 48.782 112.855 48.644C113.113 48.5 113.407 48.428 113.737 48.428C114.289 48.428 114.715 48.602 115.015 48.95C115.321 49.298 115.474 49.808 115.474 50.48V53H114.331V50.588C114.331 50.204 114.253 49.91 114.097 49.706C113.947 49.502 113.707 49.4 113.377 49.4C113.053 49.4 112.783 49.514 112.567 49.742C112.357 49.97 112.252 50.288 112.252 50.696V53H111.1ZM116.477 53V48.536H117.494L117.593 49.139C117.737 48.923 117.926 48.752 118.16 48.626C118.4 48.494 118.676 48.428 118.988 48.428C119.678 48.428 120.167 48.695 120.455 49.229C120.617 48.983 120.833 48.788 121.103 48.644C121.379 48.5 121.679 48.428 122.003 48.428C122.585 48.428 123.032 48.602 123.344 48.95C123.656 49.298 123.812 49.808 123.812 50.48V53H122.66V50.588C122.66 50.204 122.585 49.91 122.435 49.706C122.291 49.502 122.066 49.4 121.76 49.4C121.448 49.4 121.196 49.514 121.004 49.742C120.818 49.97 120.725 50.288 120.725 50.696V53H119.573V50.588C119.573 50.204 119.498 49.91 119.348 49.706C119.198 49.502 118.967 49.4 118.655 49.4C118.349 49.4 118.1 49.514 117.908 49.742C117.722 49.97 117.629 50.288 117.629 50.696V53H116.477ZM126.345 53.108C125.961 53.108 125.646 53.048 125.4 52.928C125.154 52.802 124.971 52.637 124.851 52.433C124.731 52.229 124.671 52.004 124.671 51.758C124.671 51.344 124.833 51.008 125.157 50.75C125.481 50.492 125.967 50.363 126.615 50.363H127.749V50.255C127.749 49.949 127.662 49.724 127.488 49.58C127.314 49.436 127.098 49.364 126.84 49.364C126.606 49.364 126.402 49.421 126.228 49.535C126.054 49.643 125.946 49.805 125.904 50.021H124.779C124.809 49.697 124.917 49.415 125.103 49.175C125.295 48.935 125.541 48.752 125.841 48.626C126.141 48.494 126.477 48.428 126.849 48.428C127.485 48.428 127.986 48.587 128.352 48.905C128.718 49.223 128.901 49.673 128.901 50.255V53H127.92L127.812 52.28C127.68 52.52 127.494 52.718 127.254 52.874C127.02 53.03 126.717 53.108 126.345 53.108ZM126.606 52.208C126.936 52.208 127.191 52.1 127.371 51.884C127.557 51.668 127.674 51.401 127.722 51.083H126.741C126.435 51.083 126.216 51.14 126.084 51.254C125.952 51.362 125.886 51.497 125.886 51.659C125.886 51.833 125.952 51.968 126.084 52.064C126.216 52.16 126.39 52.208 126.606 52.208ZM129.902 53V48.536H130.928L131.036 49.373C131.198 49.085 131.417 48.857 131.693 48.689C131.975 48.515 132.305 48.428 132.683 48.428V49.643H132.359C132.107 49.643 131.882 49.682 131.684 49.76C131.486 49.838 131.33 49.973 131.216 50.165C131.108 50.357 131.054 50.624 131.054 50.966V53H129.902ZM133.371 53V46.52H134.523V50.345L136.107 48.536H137.475L135.648 50.57L137.772 53H136.332L134.523 50.759V53H133.371ZM140.187 53.108C139.737 53.108 139.338 53.012 138.99 52.82C138.642 52.628 138.369 52.358 138.171 52.01C137.973 51.662 137.874 51.26 137.874 50.804C137.874 50.342 137.97 49.931 138.162 49.571C138.36 49.211 138.63 48.932 138.972 48.734C139.32 48.53 139.728 48.428 140.196 48.428C140.634 48.428 141.021 48.524 141.357 48.716C141.693 48.908 141.954 49.172 142.14 49.508C142.332 49.838 142.428 50.207 142.428 50.615C142.428 50.681 142.425 50.75 142.419 50.822C142.419 50.894 142.416 50.969 142.41 51.047H139.017C139.041 51.395 139.161 51.668 139.377 51.866C139.599 52.064 139.866 52.163 140.178 52.163C140.412 52.163 140.607 52.112 140.763 52.01C140.925 51.902 141.045 51.764 141.123 51.596H142.293C142.209 51.878 142.068 52.136 141.87 52.37C141.678 52.598 141.438 52.778 141.15 52.91C140.868 53.042 140.547 53.108 140.187 53.108ZM140.196 49.364C139.914 49.364 139.665 49.445 139.449 49.607C139.233 49.763 139.095 50.003 139.035 50.327H141.258C141.24 50.033 141.132 49.799 140.934 49.625C140.736 49.451 140.49 49.364 140.196 49.364ZM145.35 53.108C144.93 53.108 144.555 53.006 144.225 52.802C143.895 52.598 143.634 52.319 143.442 51.965C143.25 51.611 143.154 51.209 143.154 50.759C143.154 50.309 143.25 49.91 143.442 49.562C143.634 49.208 143.895 48.932 144.225 48.734C144.555 48.53 144.93 48.428 145.35 48.428C145.686 48.428 145.98 48.491 146.232 48.617C146.484 48.743 146.688 48.92 146.844 49.148V46.52H147.996V53H146.97L146.844 52.361C146.7 52.559 146.508 52.733 146.268 52.883C146.034 53.033 145.728 53.108 145.35 53.108ZM145.593 52.1C145.965 52.1 146.268 51.977 146.502 51.731C146.742 51.479 146.862 51.158 146.862 50.768C146.862 50.378 146.742 50.06 146.502 49.814C146.268 49.562 145.965 49.436 145.593 49.436C145.227 49.436 144.924 49.559 144.684 49.805C144.444 50.051 144.324 50.369 144.324 50.759C144.324 51.149 144.444 51.47 144.684 51.722C144.924 51.974 145.227 52.1 145.593 52.1Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10322_11572)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 120,
    width: 38,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 120,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint43_linear_10322_11572)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 120,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint44_linear_10322_11572)"
  }))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3624 134.849C46.1258 134.611 46.1258 134.226 46.3624 133.988L48.7109 131.61H39.5053C39.1715 131.61 38.8985 131.335 38.8985 130.999C38.8985 130.663 39.1715 130.388 39.5053 130.388H48.7109L46.3564 128.017C46.1197 127.779 46.1197 127.394 46.3564 127.155C46.593 126.917 46.9753 126.917 47.212 127.155L50.6102 130.571C50.8469 130.81 50.8469 131.195 50.6102 131.433L47.2181 134.849C46.9814 135.081 46.593 135.081 46.3624 134.849Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10322_11572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6234 37.0198C47.6234 38.6472 48.1023 38.7013 48.9395 38.7013V38.8775H45.43V38.7013C46.0816 38.7013 46.3074 38.349 46.3074 37.0608V30.7833C46.3074 29.8475 46.1209 29.5092 45.4565 29.5092V29.333H47.8629C50.5087 29.333 52.2634 29.6583 52.2634 32.0714C52.2634 34.4846 50.5087 34.7968 47.8629 34.7968H47.6234V37.0208V37.0198ZM47.8629 34.6197C49.4851 34.6197 50.8139 34.5797 50.8139 32.0714C50.8139 29.5632 49.4184 29.5092 47.8629 29.5092H47.6234V34.6207H47.8629V34.6197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9485 38.8782H52.7149V38.7021C53.2203 38.5529 53.2468 38.3087 53.2468 37.6171V33.8618C53.2468 33.3874 53.1407 33.1972 52.5823 33.0481V32.885L54.4038 32.4917V37.6171C54.4038 38.3758 54.4705 38.58 54.9485 38.7021V38.8782ZM53.021 30.676C53.021 30.2826 53.3135 29.9844 53.6991 29.9844C54.0848 29.9844 54.3773 30.2826 54.3773 30.676C54.3773 31.0693 54.0711 31.3676 53.6991 31.3676C53.3272 31.3676 53.021 31.0553 53.021 30.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.303 38.8778H59.0694V38.7147C59.5748 38.5655 59.6013 38.3083 59.6013 37.6167V34.7012C59.6013 33.7793 59.1224 33.1688 58.245 33.1688C57.5541 33.1688 56.9957 33.8464 56.8887 34.3349V37.6297C56.8887 38.3754 56.9555 38.5786 57.4334 38.7007V38.8769H55.1998V38.7007C55.7052 38.5516 55.718 38.3213 55.718 37.6297V33.8474C55.718 33.373 55.6111 33.1968 55.0536 33.0477V32.8845L56.8878 32.4912V33.9145C57.1666 33.1278 58.0842 32.4912 58.9222 32.4912C59.9988 32.4912 60.7565 33.0197 60.7565 34.6601V37.6158C60.7565 38.3614 60.836 38.5916 61.3012 38.7137V38.8769L61.303 38.8778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4985 38.8778H65.2649V38.7147C65.7703 38.5655 65.7968 38.3083 65.7968 37.6167V34.7012C65.7968 33.7793 65.3179 33.1688 64.4405 33.1688C63.7496 33.1688 63.1912 33.8464 63.0842 34.3349V37.6297C63.0842 38.3754 63.151 38.5786 63.6289 38.7007V38.8769H61.3953V38.7007C61.9007 38.5516 61.9135 38.3213 61.9135 37.6297V33.8474C61.9135 33.373 61.8075 33.1968 61.2491 33.0477V32.8845L63.0833 32.4912V33.9145C63.3621 33.1278 64.2797 32.4912 65.1177 32.4912C66.1943 32.4912 66.952 33.0197 66.952 34.6601V37.6158C66.952 38.3614 67.0315 38.5916 67.4967 38.7137V38.8769L67.4985 38.8778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4545 38.0099L73.6135 38.078C73.534 38.4853 73.0816 38.9998 72.3907 38.9998C72.3907 38.9998 71.3406 39.0268 71.2611 37.8608C71.0747 38.5114 70.3042 38.9998 69.3729 38.9998C69.3729 38.9998 67.8577 38.9998 67.8577 37.6035C67.8577 36.2073 68.9873 35.9491 71.2611 35.3535V34.5668C71.2611 33.1706 70.5702 32.3839 69.5064 32.8854C68.9882 33.1436 68.9087 33.4008 68.9882 33.4139C69.1481 33.4409 69.2944 33.5089 69.4004 33.6581C69.5996 33.9293 69.5466 34.3366 69.2669 34.5398C69.001 34.757 68.6153 34.702 68.4161 34.4177C68.2698 34.2145 68.2433 33.9433 68.3494 33.7531C68.4426 33.5499 68.6683 33.1436 69.3867 32.7502C69.9579 32.452 70.6095 32.492 70.6095 32.492C72.0581 32.492 72.4574 33.59 72.4574 35.2034V37.5085C72.4574 37.5085 72.4446 38.3622 73.0561 38.3622C73.0561 38.3622 73.3613 38.3622 73.4545 38.0099ZM69.0412 37.3183C69.0412 37.7117 69.2806 38.3893 70.0913 38.3893C70.7959 38.3893 71.1286 37.8738 71.2611 37.5485V35.5287C69.7193 35.9081 69.0412 36.5046 69.0412 37.3183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1848 37.2094C79.0386 37.887 78.3605 38.999 76.7254 38.999C75.2367 38.999 73.8274 37.7518 73.8274 35.7591C73.8274 34.0916 75.0237 32.4912 77.0581 32.4912C78.3614 32.4912 78.7598 33.1017 78.8796 33.318C78.9856 33.5081 79.0121 33.7654 78.8924 33.9825C78.7196 34.2668 78.3211 34.3898 78.0415 34.2128C77.7353 34.0366 77.6421 33.6433 77.8158 33.359C77.909 33.1968 78.0552 33.0877 78.1877 33.0747C78.3074 33.0477 77.9483 32.6683 77.0581 32.6683C76.5262 32.6683 75.0639 33.0747 75.0639 35.6099C75.0639 37.4135 76.061 38.1592 77.0051 38.2533C77.9757 38.3344 78.8 37.6978 79.0395 37.1413L79.1857 37.2094H79.1848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7639 38.8779H79.5303V38.7017C80.0357 38.5526 80.0622 38.3224 80.0622 37.6308V30.1872C80.0622 29.7128 79.9425 29.5227 79.3969 29.4145V29.2384L81.2311 28.8721V37.6308C81.2311 38.3764 81.2978 38.5796 81.763 38.7017V38.8779H81.7639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3873 37.2774C87.241 37.915 86.5099 38.999 84.9407 38.999C83.2792 38.999 82.0956 37.5887 82.0956 35.7991C82.0956 33.7924 83.345 32.4912 84.9937 32.4912C86.5355 32.4912 87.5993 33.4941 87.5993 35.623H83.345C83.398 37.4536 84.1958 38.1853 85.2459 38.2943C86.0438 38.3754 86.9879 37.8739 87.2264 37.2094L87.3854 37.2774H87.3873ZM86.4569 35.4468C86.4569 33.4671 85.5932 32.6674 84.9544 32.6674C84.1968 32.6674 83.3459 33.7383 83.3459 35.4468H86.4569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 32.5028H89.62V33.9624H88.9812V32.5028H87.6011V31.8512H88.9812V30.3916H89.62V31.8512H91V32.5028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3688 28.5273H34.0964V34.3416H34.3688C36.214 34.3416 37.7256 34.296 37.7256 31.4429C37.7256 28.5898 36.1381 28.5283 34.3688 28.5283V28.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3734 31.4421C39.3734 34.1712 37.3774 34.5413 34.3679 34.5413H34.0955V37.07C34.0955 38.2509 34.3176 38.703 34.7252 38.8754H43.9741L39.4804 30.9369L39.3003 30.6182C39.3478 30.8661 39.3734 31.1383 39.3734 31.4403V31.4421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5994 37.1171V29.9774C32.5994 29.0248 32.4285 28.6166 31.8509 28.542L30.4938 30.9393L26 38.8759H32.1105C32.4651 38.6783 32.5994 38.1759 32.5994 37.1161V37.1171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3688 28.3268H38.0034L34.9875 23L31.9725 28.3268H34.3688Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10322_11572",
    x: 0,
    y: 0,
    width: 189,
    height: 230,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_11572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_11572",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10322_11572",
    x: 18,
    y: 112,
    width: 54,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_11572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_11572",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10322_11572",
    x1: 79.6996,
    y1: 157.114,
    x2: 79.6996,
    y2: 207.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10322_11572",
    x1: 65.9472,
    y1: 156.177,
    x2: 65.9472,
    y2: 206.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10322_11572",
    x1: 72.6664,
    y1: 167.888,
    x2: 72.6664,
    y2: 215.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10322_11572",
    x1: 85.2219,
    y1: 171.095,
    x2: 85.2219,
    y2: 215.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10322_11572",
    x1: 60.2832,
    y1: 176.448,
    x2: 60.2832,
    y2: 213.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10322_11572",
    x1: 72.7485,
    y1: 205.784,
    x2: 72.7485,
    y2: 224.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10322_11572",
    x1: 177.702,
    y1: 172.398,
    x2: 130.563,
    y2: 172.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10322_11572",
    x1: 152.006,
    y1: 218.157,
    x2: 152.006,
    y2: 202.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10322_11572",
    x1: 152.006,
    y1: 141.712,
    x2: 152.006,
    y2: 198.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#499EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3581A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_10322_11572",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.544) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10322_11572",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.544) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_10322_11572",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.544) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10322_11572",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.544) rotate(180) scale(35.0529 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_10322_11572",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.799 164.544) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10322_11572",
    x1: 175.356,
    y1: 220.181,
    x2: 128.656,
    y2: 220.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10322_11572",
    x1: 186.029,
    y1: 175.269,
    x2: 127.928,
    y2: 175.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10322_11572",
    x1: 84.3999,
    y1: 194.539,
    x2: 84.4978,
    y2: 227.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10322_11572",
    x1: 181.313,
    y1: 220.432,
    x2: 182.969,
    y2: 226.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10322_11572",
    x1: 182.68,
    y1: 220.248,
    x2: 182.7,
    y2: 226.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10322_11572",
    x1: 181.317,
    y1: 220.429,
    x2: 182.973,
    y2: 226.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10322_11572",
    x1: 173.529,
    y1: 152.237,
    x2: 173.746,
    y2: 224.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10322_11572",
    x1: 146.006,
    y1: 219.148,
    x2: 142.657,
    y2: 230.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10322_11572",
    x1: 145.072,
    y1: 222.452,
    x2: 142.607,
    y2: 231.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10322_11572",
    x1: 153.86,
    y1: 152.295,
    x2: 154.077,
    y2: 224.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10322_11572",
    x1: 164.184,
    y1: 145.965,
    x2: 164.219,
    y2: 157.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10322_11572",
    x1: 164.201,
    y1: 152.266,
    x2: 164.418,
    y2: 224.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10322_11572",
    x1: 164.21,
    y1: 155.107,
    x2: 164.233,
    y2: 162.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10322_11572",
    x1: 148.219,
    y1: 193.633,
    x2: 148.318,
    y2: 226.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10322_11572",
    x1: 144.528,
    y1: 193.644,
    x2: 144.627,
    y2: 226.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10322_11572",
    x1: 166.583,
    y1: 193.578,
    x2: 166.682,
    y2: 226.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10322_11572",
    x1: 121.607,
    y1: 195.565,
    x2: 121.644,
    y2: 207.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10322_11572",
    x1: 104.872,
    y1: 195.615,
    x2: 104.909,
    y2: 207.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10322_11572",
    x1: 121.585,
    y1: 188.266,
    x2: 121.608,
    y2: 195.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10322_11572",
    x1: 107.935,
    y1: 188.307,
    x2: 107.958,
    y2: 195.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10322_11572",
    x1: 121.641,
    y1: 207.311,
    x2: 121.7,
    y2: 227.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10322_11572",
    x1: 153.628,
    y1: 186.225,
    x2: 153.628,
    y2: 227.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10322_11572",
    x1: 153.628,
    y1: 187.329,
    x2: 153.628,
    y2: 226.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10322_11572",
    x1: 153.628,
    y1: 186.225,
    x2: 153.628,
    y2: 227.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10322_11572",
    x1: 153.628,
    y1: 186.224,
    x2: 153.628,
    y2: 227.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10322_11572",
    x1: 153.628,
    y1: 186.225,
    x2: 153.628,
    y2: 227.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10322_11572",
    x1: 153.628,
    y1: 186.225,
    x2: 153.628,
    y2: 227.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10322_11572",
    x1: 153.586,
    y1: 195.623,
    x2: 153.586,
    y2: 207.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10322_11572",
    x1: 153.635,
    y1: 216.279,
    x2: 153.635,
    y2: 223.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10322_11572",
    x1: 64,
    y1: 142,
    x2: 24.0901,
    y2: 137.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10322_11572",
    x1: 45,
    y1: 88.6042,
    x2: 45,
    y2: 142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10322_11572"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 185,
    height: 226,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10322_11572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 16,
    fill: "white",
    transform: "translate(26 23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpShort);
export default __webpack_public_path__ + "static/media/CP_Short.7281dc22d40f00491a7229014b9d339c.svg";
export { ForwardRef as ReactComponent };